/* eslint-disable no-template-curly-in-string */

export const translations = {
  EN: {
    "actions.cancel": "Cancel",
    "actions.create": "Create",
    "actions.activate": "Activate",
    "actions.deactivate": "Deactivate",
    "actions.clear": "clear all",
    "actions.submit": "Submit",
    "actions.done": "Done",
    "actions.skip": "Skip",
    "actions.undo": "Undo",
    "actions.duplicate": "Duplicate",

    "select.option.placeholder": "Select an option",

    // This is for Rate Card Feature
    "channel.new": "New Channel",
    "channel.existing": "Existing Channel",
    details: "Details",
    loading: "Loading",
    "individual.spots": "Individual Spots",
    name: "Name",
    "rate.card.media.owner": "Media Owner",
    "new.rate.card": "New Rate Card",
    "rate.card.details": "Details",
    "rate.card.loading": "Loading",
    "rate.card.media.type": "Media Type",
    "rate.card.effective.date": "Effective Date",
    "rate.card.client": "Client",
    "rate.card.negotiation.type": "Negotiation Type",
    "rate.card.negotiation.type._NEGOTIATED": "Negotiated Value",
    "rate.card.negotiation.type._CPP": "CPP",
    "rate.cards.noresults.title": "No results found",
    "base.rate": "Base Rate",
    "actions.new.base_rate": "+New Base Rate",
    "actions.copy.base_rate": "Copy Base Rate",
    "actions.rate_card": "New Rate Card",
    "tabs.rate_card": "Rate Cards",
    "location.create.title": "Add Location",
    "channel.create.title": "Add Channel",
    "channel.placeholder": "Channel (optional)",
    "location.placeholder": "Location (optional)",
    "vendors.columns.media_type": "Media Type",
    "vendors.columns.effective-date": "Effective Date",
    "add.row": "Add Row",
    "add.criteria.column": "Add Criteria Column",
    "add.duration": "Add Duration",
    "filter.channels": "Channels",
    "filter.mediaType": "Media Type",
    "filter.dateRange": "Date Range",
    "packages.name": "Package",
    "packages.status": "Status",
    "packages.cost": "Package Cost",
    "packages.media.type": "Media Type",
    "packages.spot.duration": "Spot Duration",
    "packages.expiration.date": "Expiry Date",
    "package.actions": "Actions",
    "packages.list.empty": "No Packages to display",
    "new.card.package": "New Package",
    "package.delete.action": "Delete",
    "package.delete.success": "Package Deleted Successfully",
    "package.modal.delete.title": "Delete package",
    "package.modal.delete.description":
      "Are you sure you want to delete this package?",
    "package.name": "Name",
    "package.spotsDuration": "Spots Duration",
    "package.cost": "Package Cost",
    "package.blackout.period": "Blackout Period",
    "package.value": "Package Value",
    "packages.submedia.type": "Submedia Type",
    "packages.list.empty.subtitle":
      "Start now creating the first one by clicking",
    "packages.list.add_button": "New Package",
    "package.empty.lineItem": "No Line Items assigned to this Submedia yet",
    "package.empty.add.lineItem": "Add Line Items",
    "packages.submedias.empty.list":
      "Start creating your package by adding Line Items within Submedia Types",
    "packages.submedias.empty.list.add": "Add Submedia Type",
    "submedia.modal.delete.title": "Delete Submedia Type",
    "submedia.modal.delete.description":
      "Are you sure you want to delete this Submedia Type?",
    "lineitem.modal.delete.title": "Delete Line Item",
    "lineitem.modal.delete.description":
      "Are you sure you want to delete this Line Item?",
    "package.modal.deactivate.title": "Deactivate Package",
    "package.modal.activate.title": "Activate Package",
    "package.activate.error": "error activating package",
    "package.deactivate.error": "error deactivating package",
    "package.activate.success": "package activated",
    "package.deactivate.success": "package deactivated",
    "package.modal.activate.description":
      "Are you sure you want to activate this package?",
    "package.modal.deactivate.description":
      "Are you sure you want to deactivate this package?",
    "packages.broadcastHours": "Broadcast Hours",
    "packages.broadcastHours.daysOfWeek": "Days of Week",
    "packages.broadcastHours.timeBelt": "Time Belt",
    "packages.broadcastHours.exclude": "Exclude",
    "packages.broadcastHours.day": "Day",
    "packages.broadcastHours.time": "Time",
    "packages.broadcastHours.start": "Start",
    "packages.broadcastHours.end": "End",
    "packages.filters.title": "Filter Packages",
    //

    "columns.actions": "Actions",

    "tabs.profile": "Profile",
    "tabs.media_types": "Media Types",
    "tabs.costs": "Costs",
    "tabs.commissions": "Commissions",
    "tabs.documents": "Documents",
    "tabs.taxes": "Taxes",

    "plan.dropzone.instructions":
      "Make sure your column header is in the first line, lorem ypsum dot color sit amet lorem ypsum dot color sit amet, lorem ypsum dot color sit amet",
    "companies.list.local_name": "Local Name",
    "campaign.audience.age_group": "Age Group",
    "plan.view.details": "View Details",
    "campaign.overview.timespan": "Start - End",
    "campaign.submit_for_approval": "Submit for approval",
    "client.tabs.flow": "flow",
    "client.flow.flags.authorizationMediaPlan": "Media Plan",
    "client.flow.flags.mediaTypeBudgetReAuthorization": "Budget",
    "customize.table.end": "End Date",
    "agency.documents.delete.confirm": "Delete",
    "plan.preview.retry_link": "Change file",
    "client.button.cancel": "cancel",
    "client.teams.managing-director": "Managing Director",
    "plan.documents.delete.cancel": "Cancel",
    "agency.header.suffix": "agency",
    "plan.documents.delete.prompt": "Delete File?",
    "customize.columns.button": "Columns",
    "campaign.activity.title": "Campaign Activity Log",
    "agency.input.name": "Agency Name",
    "agency.edit.name": "Agency Name",
    "inputs.code.placeholder": "Enter Code",
    code: "Code",
    "client.country": "Country",
    "plans.noresults.title": "No results found",
    "client.flow.approverLevels.add": "Add another level",
    "document.uploaded.title": "File Uploaded",
    "agency.edit.company": "Company Assigned",
    "agencies.list.code": "Code",
    "agency.documents.view_all": "View all",
    "customize.table.client": "Client Name",
    "campaign.audience.required": "choose a demographic first",
    "plan.view.no_data": "Oh no!",
    "plan.viewmode.calendar": "Flowchart",
    "client.flow.flags.campaignProductReAuthorization": "Product",
    "clients.flow.requirement.approval": "Approval",
    "campaigns.sort.end.asc": "Ends First",
    "client.tags.key": "Key",
    "campaign.documents.report": "Report",
    "customize.table.start": "Start Date",
    "supplierr.button.update": "Save",
    "campaigns.sort.budget.desc": "Largest Budget",
    "inputs.local_name.placeholder": "Enter Local Name",
    "client.flow.approvals.title": "Approvals",
    "agency.client.button.submit": "Assign",
    "agency.client.button.clear": "Clear All",
    "clients.flow.requirement.authorization": "Authorization",
    "admin.i18n.expand": "Show list",
    "header.greeting": "Hello, ",
    "clients.list.region": "Region",
    "plan.documents": "Creatives",
    "filters.label": "Filters",
    "client.flow.levels.amount.placeholder": "Type amount",
    "agency.button.submit": "Assign",
    "agency.button.create": "Create",
    "client.flow.approverLevels.title": "Levels",
    "plan.upload.success": "Media Plan was imported successfully",
    "agency.create.button": "+ Create new agency",
    "agency.list.delete.action": "Delete",
    "supplier-groups.list.delete.action": "Delete",
    "supplier-groups.list.delete.title": "Delete Vendor Group",
    "supplier-groups.list.delete.description":
      "Are you sure you want to delete the Vendor Group?",
    "supplier-groups.create.button": "+ Create new Supplier",
    "supplier-groups.tabs.profile": "Profile",
    "supplier-groups.tabs.suppliers": "Vendors",
    "supplier-groups.tabs.mediatypes": "Media Types",
    "supplier-groups.tabs.fields": "Fields",
    "supplier-groups.tabs.documents": "Documents",
    "supplier-groups.tabs.code": "Code",
    "supplier-groups.create.title": "Create Vendor Group",
    "supplier-groups.options.activate": "Activate",
    "vendorgroups.list.name": "Vendor Group",
    "vendorgroups.list.vendors": "Vendors",
    "vendorgroups.create.button": "+ new Vendor Group",
    "vendorgroups.list.suppliers": "Vendor",
    "supplier-groups.input.name": "Name",
    "supplier-groups.input.code": "Code",
    "nav.admin.clientgroups": "Client Groups",
    "client-groups.list.name": "Client Groups",
    "client-groups.list.code": "Code",
    "client-groups.list.status": "Status",
    "client-groups.list.clients": "Clients",
    "client-groups.list.actions": "Actions",
    "client-groups.list.delete.action": "Delete",
    "clientgroups.create.button": "+ new Client Group",
    "client-groups.input.name": "Name",
    "client-groups.input.code": "Code",
    "client-groups.button.cancel": "Cancel",
    "client-groups.button.submit": "Create",
    "client-groups.create.title": "Create Client Group",
    "client-groups.list.delete.title": "Delete Client Group",
    "client-groups.list.delete.description":
      "Are you sure you want to delete the Client Group?",
    "clients.list.delete.action": "Delete",
    "clients.list.delete.title": "Delete Client",
    "clients.list.delete.description":
      "Are you sure you want to delete this Client ?",
    "client-groups.tabs.profile": "Profile",
    "client-groups.tabs.clients": "Clients",
    "client-groups.tabs.mediatypes": "Media Types",
    "client-groups.tabs.fields": "Fields",
    "client-groups.tabs.documents": "Documents",
    "client-groups.profile.details": "Details",
    "client-groups.profile.addresses": "Addresses",
    "client-groups.profile.business-address": "Business Address",
    "client-groups.profile.address1": "Address 1",
    "client-groups.profile.address2": "Address 2",
    "client-groups.profile.billing-contact": "Contact Information",
    "client-groups.profile.country": "Country",
    "client-groups.profile.state": "State/Province",
    "client-groups.profile.city": "City",
    "client-groups.profile.zipCode": "Zip Code",
    "client-groups.profile.contact-info": "Contact Info",
    "client-groups.profile.title": "Title",
    "client-groups.profile.name": "Name",
    "client-groups.profile.email": "Email",
    "client-groups.profile.ntype": "Number Type",
    "client-groups.profile.number": "Number",
    "client-groups.profile.extension": "Extension",
    "client-groups.profile.add-phone": "Add Phone",
    "client-groups.list.client": "Client",
    "clients.button.add": "+ Assign Client",
    "clients.create.title": "Assign Client",
    "clients.associate.filled": "Clients selected",
    "clients.assign": "Select Clients to assign",
    "clients.button.cancel": "Cancel",
    "clients.button.submit": "Assign",
    "clients.button.clear": "Clear All",
    "supplier-groups.modal.activate.title": "Activate Vendor Group",
    "supplier-groups.modal.activate.description":
      "Are you sure you want to activate this vendor group?",
    "supplier-groups.modal.deactivate.title": "Deactivate Vendor Group",
    "supplier-groups.modal.deactivate.description":
      "Are you sure you want to deactivate this vendor group?",
    "client-groups.modal.activate.title": "Activate Client Group",
    "client-groups.modal.activate.description":
      "Are you sure you want to activate this client group?",
    "client-groups.modal.deactivate.title": "Deactivate Client Group",
    "client-groups.modal.deactivate.description":
      "Are you sure you want to deactivate this client group?",
    "clients.input.name": "Name",
    "clients.input.code": "Code",
    "client-groups.options.activate": "Activate",
    "client-groups.empty.title": "No Client Groups to display",
    "client-groups.empty.subtitle":
      "Start now creating the first one by clicking",
    "clientgroups.documents.description": "documents",
    "clientgroups.documents.logo": "Logo",
    "clientgroups.documents.other": "Other",
    "client.tags.custom": "Custom",
    "campaigns.empty.subtitle": "Start now creating the first one by clicking",
    "client.teams.planners": "Planners",
    "client.flow.reauthorization.by.client":
      "Re-Authorization Required By Client",
    "client.flow.levels.approverEmail": "Approver's Email",
    "client.documents.delete.prompt": "Delete file?",
    "client.flow.approverLevels.approversFirstName.placeholder":
      "Type first name",
    "agency.input.campaign": "Company Assigned",
    "plans.list.bookedItemsPercentage": "Booked Progress",
    "plans.list.budget_tracker": "Budget Tracker",
    "clients.flow.requirement.both": "Both",
    "plan.create.import.template.version": "Latest version.",
    "filters.company": "Company",
    "filters.agency": "Agency",
    "filters.market": "Market",
    "filters.clients": "Clients",
    "filters.supplier": "Supplier",
    "filters.summary": "Summary",
    "filters.quarter": "Quarter",
    "filters.mediaType": "Media Type",
    "filters.submediaType": "Submedia Type",
    "filters.submediaTypes": "Sub Media Type",
    "filters.bookingOrderNumber": "BO Number",
    "filters.product": "Product",
    "filters.date": "Date",
    "filters.lastUpdated": "Last Updated",
    "filters.clientProduct": "Product",
    "filters.vendorProduct": "Vendor Product",
    "filters.vendor": "Vendors",
    "filters.intermediary": "Intermediary",
    "filters.mediaPlan": "Media Plan",
    "client.documents.delete.cancel": "cancel",
    "status.APPROVED": "Approved",
    "status.BOOKED": "Booked",
    "status.NON_BOOKED": "Non Booked",
    "status.UNDER_REVISION": "Under Revision",
    "status.PENDING_REVISION": "Pending Revision",
    "status.UNDER_INTERCOMPANY_REVISION": "Under I/C Revision",
    "status.PENDING_INTERCOMPANY_REVISION": "Pending I/C Revision",
    "status.UNDER_CHANGE_REQUEST": "Under Change Request",
    "client.flow.flags.requiresAuthorization": "Authorization",
    "client.flow.approverLevels.approverFirstName": "Approver's First Name",
    "client.flow.approverLevels.amount": "Amount Threshold",
    "client.flow.approverLevels.approverInfo": "Approver's info",
    "plan.upload.validation.failed.message1": "Your file contains errors.",
    "client.flow.flags.mediaTypeProductReApproval": "Product",
    "plan.upload.validation.failed.message2":
      "Please fix the following errors and upload the file again",
    "agency.input.code": "Agency Code",
    "clients.list.country": "Country",
    "campaign.tabs.details": "Details",
    "campaign.tabs.overview": "Overview",
    "campaign.tabs.documents": "documents",
    "campaign.tabs.performance": "performance",
    "campaign.tabs.mba.config": "MBA Configuration",
    "table.filters.reset": "clear all",
    "status.": " - ",
    "admin.i18n.update": "Update",
    "supplier.code": "Supplier Code",
    "supplier.profile.business-adress": "Business Address",
    "table.campaigns.filters.title": "Filter Campaigns",
    "table.bookingOrders.filters.title": "Filter Booking Orders",
    "table.plans.filter.title": "Filter Media Plans",
    "admin.tabs.agencies": "Agencies",
    "plans.list.currency": "Currency",
    "plans.list.number": "Number",
    "plans.list.mediaTypes": "Media Types",
    "plans.list.mediaTypes.more": "more",
    "plans.list.product": "Product",
    "plan.upload.failure": "Oh no!!",
    "countries.list.name": "Country",
    "plans.list.actions": "Actions",
    "plans.list.delete.title": "Delete Media Plan",
    "plans.list.delete.description":
      "Are you sure you want to delete the Media Plan?",
    "plans.list.delete.action": "Delete",
    "plans.list.activate.title": "Activate Media Plan",
    "plans.list.activate.description":
      "Are you sure you want to activate the Media Plan?",
    "plans.list.activate.action": "Activate",
    "plans.list.complete.title": "Complete Media Plan",
    "plans.list.complete.description":
      "Are you sure you want to complete the Media Plan?",
    "plans.list.complete.action": "Complete",
    "plan.documents.type": "Creative Type",
    "agency.submediatype.selected": "Selected Submedia Types(s)",
    "client.flow.flags.mediaPlanProductReAuthorization": "Product",
    "admin.tabs.labels": "Labels",
    "nav.labels": "Labels",
    "campaigns.sort.updated.desc": "Updated Last",
    "admin.i18n.success": "Labels uploaded successfuly",
    "plan.create.campaign": "Campaign",
    "plan.create.overview.client": "Client",
    "plan.create.overview.agency": "Agency",
    "plan.create.overview.name": "Name",
    "plan.create.overview.budget": "Budget",
    "plan.create.overview.period": "Period",
    "plan.create.overview.mediaPlan": "Media Plan",
    "plan.create.overview.mediaTypes": "Media Types",
    "plan.create.overview.targets": "Targets",
    "plan.create.overview.targetA": "Target A",
    "plan.create.overview.targetB": "Target B",
    "plan.create.scenario": "MPLScenario",
    "plan.dropzone.browse": "browse",
    "client.flow.flags.lineItemAuthorization": "Line Item",
    "agency.header.prefix": "Edit",
    "plan.create.title": "Create New Media Plan",
    "campaigns.sort.created.asc": "Created First",
    "campaigns.sort.updated.asc": "Updated First",
    "client.flow.flags.mediaPlanBudgetReApproval": "Budget",
    "campaign.input.start": "Start Date",
    "plan.upload.success.title": "Validation Completed",
    "agencies.list.company": "Company",
    "plan.upload.validating.subtitle": "Uploading your file…",
    "notifications.read_all": "Mark All as Read",
    "notifications.empty": "No notifications",
    "notifications.noresults.subtitle":
      "We will notify you when something arrives",
    "duplication.team.user.assignment": "Duplicate Team Member",
    "cannot.delete.market": "Cannot Delete Market",
    "cannot.delete.client.group": "Cannot Delete Client Group",
    "cannot.delete.supplier.group": "Cannot Delete Vendor Group",
    "mba.general-settings.title": "General Settings",
    "mba.general-settings.font": "Font",
    "mba.general-settings.intermediaryVendors": "Intermediary Vendors",
    "mba.general-settings.fontSize": "Font Size (px)",
    "mba.general-settings.borderColor": "Border Color",
    "mba.general-settings.borderColor-title": "hex code...",
    "mba.general-settings.borderSize": "Border Size (px)",
    "mba.save.changes": "Save Changes",
    "mba.discard.changes": "Discard Changes",
    "borderData.thin": "Thin",
    "borderData.medium": "Medium",
    "borderData.thick": "Thick",
    "intermediaryData.show_vendors_only": "Show Vendors Only",
    "intermediaryData.show_mo_and_vendor": "Show MO and Vendor",
    "agency.client.mba-configuration": "MBA Configuration",
    "agency.client.campaign-mba-configuration": "Campaign MBA Configuration",
    "mba-configuration.version-tracker.toggle": "Export Version Tracker:",
    "mba.media-types-fields.title": "Customize Media Fields",
    "mba.media-types-settings.title": "Media Types Settings",
    "mba.media-types-settings.headersFont": "Headers Font Color",
    "mba.media-types-settings.headersBackground": "Headers Background",
    "mba.media-types-settings.spotsBackground": "Spots Background",
    "mba.media-types-settings.spotsFont": "Spots Font Color",
    "mba.media-types-settings.weekendSpotsBackground":
      "Weekend Spots Background",
    "mba.media-types-settings.calendarHeadersBackground":
      "Calendar Headers Background",
    "mba.media-types-settings.calendarHeadersFont":
      "Calendar Headers Font Color",
    "mba.media-types-settings.lineItemBackground": "Line Items Background",
    "mba.media-types-settings.lineItemFont": "Line Items Font Color",
    "mba.admin.client.cinema": "Cinema",
    "mba.admin.client.digital": "Digital",
    "mba.admin.client.event": "Event",
    "mba.admin.client.out-of-home": "Out of Home",
    "mba.admin.client.print": "Print",
    "mba.admin.client.radio": "Radio",
    "mba.admin.client.tv": "TV",
    "mba.group-media-fields.title": "Fields to group by",
    "mba.media-types-financial-summarizations.title":
      "Media Types Financial Summarization",
    "mba.media-fields-summarizations.title": "Media Fields Summarization",
    "mba.fields": "Fields",
    "mba.selected.fields": "Selected Fields & Order",
    "mba.financial.summary": "Financial Summary",
    "mba.selected.financial": "Selected Financial Summary & Order",
    "mba.config.campaign.separateSubmedias":
      "Export Submedia type in separate sheets for",
    "mba.config.campaign.tv.view": "Export format for TV Media Type",
    "mba.config.campaign.budget.insights": "Export Budget Insights",
    "mba.confif.campaign.viewBudgetCover": "Budget Cover",
    "mba.confif.campaign.viewBudgetDetails": "Budget Details",
    "mba.config.campaign.exportVersionTracker": "Export Version Tracker",
    "mba.config.campaign.label": "Label",
    "mba.config.campaign.semantic": "Semantic",
    "mba.config.campaign.dataType": "Data type",

    "notifications.filters.title": "Filter Notifications",
    "notifications.filters.time": "Time",
    "notifications.filters.time.TODAY": "Today",
    "notifications.filters.time.WEEK": "This week",
    "notifications.filters.time.MONTH": "This month",
    "notifications.filters.time.YEAR": "This year",
    "notifications.filters.actor": "Name",
    "notifications.filters.activity": "Activity",
    "notifications.filters.flags": "Flag",
    "activity.APPROVE_CAMPAIGN": "Campaign Approval",
    "activity.APPROVE_CAMPAIGN_CHANGE_REQUEST": "Campaign C.R Approval",
    "activity.APPROVE_CAMPAIGN_SUBMIT_REQUEST": "Campaign Approval Request",
    "activity.APPLY_CAMPAIGN_CHANGE_REQUEST": "Campaign C.R Application",
    "activity.APPROVE_MEDIA_PLAN": "Media Plan Approval",
    "activity.APPROVE_MEDIA_PLAN_AUTHORIZE_REQUEST":
      "Media Plan Authorization Approval Request",
    "activity.COMMENT_APPROVE_MEDIA_PLAN_AUTHORIZE_REQUEST":
      "Media Plan Authorization Approval Request Comment",
    "activity.APPROVE_MEDIA_PLAN_CHANGE_REQUEST":
      "Media Plan C.R Approval Request",
    "activity.APPROVE_MEDIA_PLAN_CHANGE_REQUEST_FOR_BUYER":
      "Media Plan C.R Approval for Buyer",
    "activity.APPROVE_MEDIA_PLAN_SUBMIT_REQUEST": "Media Plan Approval Request",
    "activity.MEDIA_PLAN_SUBMIT_REQUEST_FOR_APPROVER":
      "Media Plan Request for Approver",
    "activity.MEDIA_PLAN_CHANGE_REQUEST_FOR_APPROVER":
      "Media Plan C.R for Approver",
    "activity.MEDIA_PLAN_SUBMIT_REQUEST_GENERAL": "Media Plan Submission",
    "activity.APPROVE_MEDIA_PLAN_SUBMIT_REQUEST_GENERAL":
      "Media Plan Submission Approval",
    "activity.MEDIA_PLAN_CHANGE_REQUEST_GENERAL": "Media Plan C.R",
    "activity.APPROVE_MEDIA_PLAN_SUBMIT_REQUEST_FOR_BUYER":
      "Media Plan Submission Approval for Buyer",
    "activity.MEDIA_PLAN_AUTO_APPROVE": "Media Plan Auto Approve",
    "activity.ARCHIVE_CAMPAIGN": "Campaign Archive ",
    "activity.CAMPAIGN_CHANGE_REQUEST": "Campaign C.R",
    "activity.CAMPAIGN_CHANGE_REQUEST_GENERAL": "Campaign C.R",
    "activity.CAMPAIGN_SUBMIT_REQUEST_FOR_APPROVER":
      "Campaign Submission Request for Approver",
    "activity.CAMPAIGN_CHANGE_REQUEST_FOR_APPROVER":
      "Campaign C.R. for Approver",
    "activity.CAMPAIGN_SUBMIT_REQUEST": "Campaign Submission for Approval",
    "activity.CAMPAIGN_SUBMIT_REQUEST_GENERAL":
      "Campaign Submission for Approval",
    "activity.SUBMIT_CAMPAIGN_CHANGE_REQUEST":
      "Campaign C.R Submission for Approval",
    "activity.COMMENT_CAMPAIGN": "Campaign Commentary",
    "activity.COMMENT_CAMPAIGN_CHANGE_REQUEST": "Campaign C.R Commentary",
    "activity.COMMENT_MEDIA_PLAN": "Media Plan Commentary",
    "activity.COMMENT_MEDIA_PLAN_CHANGE_REQUEST": "Media Plan C.R Commentary",
    "activity.COMMENT_APPROVE_MEDIA_PLAN_SUBMIT_REQUEST":
      "Media Plan Approval Request Comment",
    "activity.COMPLETED_CAMPAIGN": "Campaign Completetion",
    "activity.COMPLETED_MEDIA_PLAN": "Media Plan Completion",
    "activity.EDIT_CAMPAIGN": "Campaign Edit",
    "activity.CREATE_AGENCY": "Agency Creation",
    "activity.CREATE_CAMPAIGN": "Campaign Creation",
    "activity.CANCEL_CAMPAIGN": "Campaign Cancelation",
    "activity.CAMPAIGN_STATUS_CHANGE": "Campaign Status Change",
    "activity.MEDIA_PLAN_STATUS_CHANGE": "Media Plan Status Change",
    "activity.SUBMIT_CAMPAIGN": "Campaign Submission",
    "activity.SUBMIT_MEDIA_PLAN": "Media Plan Submission",
    "activity.CREATE_CLIENT": "Client Creation",
    "activity.CREATE_MEDIA_PLAN": "Media Plan Creation",
    "activity.DELETED_BY_THE_SYSTEM_CAMPAIGN": "Campaign Deletion (System) ",
    "activity.DELETED_BY_THE_SYSTEM_MEDIA_PLAN": "Media Plan Deletion (System)",
    "activity.DELETE_AGENCY": "Agency Deletion",
    "activity.DELETE_CAMPAIGN": "Campaign Deletion",
    "activity.DELETE_CLIENT": "Client Deletion",
    "activity.DELETE_MEDIA_PLAN": "Media Plan Deletion",
    "activity.DISCARD_CAMPAIGN_CHANGE_REQUEST": "Campaign C.R Discard",
    "activity.DISCARD_MEDIA_PLAN_CHANGE_REQUEST": "Media Plan C.R Discard",
    "activity.LIVE_CAMPAIGN": "Campaign Live",
    "activity.MARK_FOR_DELETION_CAMPAIGN": "Campaign Marked for Delection",
    "activity.MARK_FOR_DELETION_MEDIA_PLAN": "Media Plan Marked for Delection",
    "activity.MEDIA_PLAN_AUTHORIZE_REQUEST": "Media Plan Authorization Request",
    "activity.MEDIA_PLAN_CHANGE_REQUEST": "Media Plan C.R",
    "activity.MEDIA_PLAN_SUBMIT_REQUEST": "Media Plan Submission for Approval",
    "activity.SUBMIT_MEDIA_PLAN_CHANGE_REQUEST":
      "Media Plan C.R Submission for Approval",
    "activity.SAVE_MEDIA_PLAN_CHANGE_REQUEST": "Media Plan C.R Save",
    "activity.REJECT_CAMPAIGN_CHANGE_REQUEST": "Campaign C.R Rejection",
    "activity.REJECT_CAMPAIGN_SUBMIT_REQUEST": "Campaign Rejection",
    "activity.REJECT_MEDIA_PLAN_AUTHORIZE_REQUEST":
      "Media Plan Authorization Rejection",
    "activity.REJECT_MEDIA_PLAN_CHANGE_REQUEST": "Media Plan C.R Rejection",
    "activity.REJECT_MEDIA_PLAN_SUBMIT_REQUEST": "Media Plan Rejection",
    "activity.TRANSFER_FUNDS_CAMPAIGN": "Campaign Funds Transfer",
    "activity.UPDATE_CAMPAIGN": "Campaign Update",
    "activity.UPDATE_MEDIA_PLAN": "Media Plan Update",
    "activity.UPDATE_BUDGET_MEDIA_PLAN": "Media Plan Budget Update",
    "activity.UPDATE_DATES_MEDIA_PLAN": "Media Plan Dates Update",
    "activity.SAVE_CAMPAIGN_CHANGE_REQUEST": "Campaign C.R Save",
    "activity.UPLOAD_DOCUMENTS": "Documents Upload",
    "activity.UPLOAD_MEDIAPLAN": "Media Plan Upload",
    "activity.MEDIA_PLAN_BOOKING_ORDER_REVISION_SUCCESSFUL":
      "Media Plan Booking Order Revision Success",
    "activity.MEDIA_PLAN_CHANGE_REQUEST_APPROVED": "Media Plan C.R Approval",
    "activity.MEDIA_PLAN_CHANGE_REQUEST_APPROVED_PLANNERS":
      "Media Plan C.R Approved for Planners",
    "activity.MEDIA_PLAN_CHANGE_REQUEST_CREATED": "Media Plan C.R Creation",
    "activity.MEDIA_PLAN_APPROVED_TO_BUYERS": "Media Plan Approval to Buyers",
    "activity.MEDIA_PLAN_CHANGE_REQUEST_DISCARDED": "Media Plan C.R Discard",
    "activity.MEDIA_PLAN_CHANGE_REQUEST_DISCARDED_PLANNERS":
      "Media Plan C.R Discard for Planners",
    "activity.MEDIA_PLAN_BOOKING_ORDER_ITEMS_POSTED":
      "Booking Order has been Posted for Billing",
    "activity.ASSIGN_AGENCY_USER": "Agency User Assignment",
    "activity.ASSIGN_MARKET_USER": "Market User Assignment",
    "activity.ASSIGN_REGIONAL_USER": "Regional User Assignment",
    "activity.ASSIGN_TEAM_TO_CLIENT": "Team to Client Assignment",
    "activity.ASSIGN_TEAM_USER": "Team User Assignment",

    "supplier.documents.delete.prompt": "Delete file?",
    "customize.table.selected": "Selected Columns",
    "client.flow.approverLevels.amount.placeholder": "Type amount",
    "supplier.profile.media-types": "Media Types",
    "supplier.profile.more.submedia-types": "more",
    "suppliergroups.suppliers.more": "more",
    "clientgroups.clients.more": "more",
    "companies.agencies.more": "more",
    "market-agencies.companies.more": "more",
    "market-agencies.agencies.more": "more",
    "companies.more": "more",
    "agencies.more": "more",
    "market-agency.company.create.button": "+ Assign to Companies",
    "agency.suppliers.button.add": "+ Assign Vendors",
    "client.flow.flags.mediaPlanApproval": "Media Plan",
    "plans.templates.title": "Templates",
    "plans.templates.subtitle":
      "Select a client from the list to download its Media Plan template in Excel format.",
    "customize.button": "Customize",
    "campaign.activity.filter.button": "Filter Log",
    "inputs.currencies.popular": "Popular currencies",
    "sort.updated.asc": "Updated First",
    "plans.list.end": "End Date",
    "plans.list.owner": "Planner (owner)",
    "companies.list.agency": "Agency",
    "companies.documents.logo": "Logo",
    "companies.documents.other": "Other",
    "campaign.stats.performance_summary": "Performance Summary",
    "campaign.documents.delete.confirm": "Delete",
    "nav.campaigns": "Campaigns",
    "customize.calendar.flight.planned": "Planned",
    "agencies.sort.updated.asc": "Updated First",
    "campaign.documents.type": "Document Type",
    "warning.modal.discard": "discard",
    "supplier.documents.delete.confirm": "confirm",
    "clientgroups.documents.delete.prompt": "Delete File?",
    "clientgroups.documents.delete.confirm": "confirm",
    "clientgroups.documents.delete.cancel": "Cancel",
    "suppliergroups.documents.delete.prompt": "Delete File?",
    "suppliergroups.documents.delete.confirm": "confirm",
    "suppliergroups.documents.delete.cancel": "Cancel",
    "company.documents.brief": "Brief",
    "company.documents.delete.prompt": "Delete File?",
    "company.documents.delete.confirm": "confirm",
    "company.documents.delete.cancel": "Cancel",
    "client.flow.approverLevels.approversLastName.placeholder":
      "Type last name",
    "client.flow.flags.campaignBudgetReAuthorization": "Budget",
    "campaign.last.update": "Last Updated",
    "campaigns.list.lastUpdate": "Last Update",
    "campaigns.list.createdDate": "Creation Date",
    "plans.list.media_plan": "Media Plan",
    "agency.submediatype.placeholder": "Select Submedia Types(s)",
    "plan.create.existing_campaign.primary": "Existing Campaign",
    "plan.documents.atb": "MBA",
    "client.region": "Region",
    "plan.button.creatives": "Creatives",
    "client.teams.agency": "Agency",
    "flow.levels.error.at.least.one": "You must add at least one level",
    "countries.list.region": "Region",
    "plan.preview.submit": "Import",
    "nav.administration": "Administration",
    "nav.admin": "Admin",
    "nav.admin.companies": "Admin Companies",
    "nav.admin.countries": "Admin Countries",
    "nav.admin.agencies": "Admin Agencies",
    "nav.admin.suppliers": "Admin Suppliers",
    "nav.admin.labels": "Admin Labels",
    "nav.admin.clients": "Admin Clients",
    "nav.admin.regions": "Regions",
    "nav.admin.team": "Admin Team",
    "nav.admin.profile": "Profile",
    "nav.admin.mediatypes": "Media Types",
    "nav.admin.teams": "Teams",
    "nav.admin.fields": "Fields",
    "nav.admin.documents": "Documents",
    "nav.admin.company": "Companies",
    "company.list.name": "Company",
    "company.list.code": "Code",
    "company.list.roc": "ROC",
    "company.list.sstRn": "SST Registration Number",
    "company.list.status": "Status",
    "company.list.agency": "Agency",
    "company.list.actions": "Actions",
    "company.list.delete.action": "Delete",
    "company.list.delete.title": "Delete Company",
    "company.list.delete.description":
      "Are you sure you want to delete this Company?",
    "company.tabs.profile": "Profile",
    "company.tabs.agencies": "Agencies",
    "company.tabs.documents": "Documents",
    "company.profile.details": "Details",
    "company.profile.addresses": "Addresses",
    "company.profile.business-address": "Business Address",
    "company.profile.address1": "Address 1",
    "company.profile.address2": "Address 2",
    "company.profile.billing-contact": "Billing Contact",
    "company.profile.country": "Country",
    "company.profile.state": "State/Province",
    "company.profile.city": "City",
    "company.profile.zipCode": "Zip Code",
    "company.list.paymentDetails": "Payment Details",
    "company.modal.deactivate.title": "Deactivate Company",
    "company.modal.deactivate.description":
      "Are you sure you want to deactivate this company?",
    "company.modal.activate.title": "Activate Company",
    "company.modal.activate.description":
      "Are you sure you want to activate this company?",
    "agency.list.agency": "Agency",
    "agency.list.status": "Status",
    "agency.list.code": "Code",
    "agency.list.actions": "Actions",
    "agency.button.add": "+ Assign Agencies",
    "company.documents.description": "documents",
    "company.empty.title": "No companies to display",
    "company.empty.subtitle": "Start now creating the first one by clicking",
    "company.list.localName": "Local Name",
    "company.list.market": "Market",
    "company.list.subRegion": "Sub-Region",
    "company.list.region": "Region",
    "company.list.profitCenter": "Profit Center",
    "company.list.costCenter": "Cost Center",
    "nav.admin.supplier-groups": "Vendor Groups",
    "supplier-groups.list.name": "Supplier Groups",
    "supplier-groups.list.code": "Code",
    "supplier-groups.list.status": "Status",
    "supplier-groups.list.suppliers": "Suppliers",
    "supplier-groups.list.actions": "Actions",
    "supplier-groups.profile.details": "Details",
    "supplier-groups.profile.addresses": "Addresses",
    "supplier-groups.profile.business-address": "Business Address",
    "supplier-groups.profile.address1": "Address 1",
    "supplier-groups.profile.address2": "Address 2",
    "supplier-groups.profile.billing-contact": "Contact Information",
    "supplier-groups.profile.country": "Country",
    "supplier-groups.profile.state": "State/Province",
    "supplier-groups.profile.city": "City",
    "supplier-groups.profile.zipCode": "Zip Code",
    "supplier-groups.profile.contact-info": "Contact Info",
    "supplier-groups.profile.title": "Title",
    "supplier-groups.profile.name": "Name",
    "supplier-groups.profile.email": "Email",
    "supplier-groups.profile.ntype": "Number Type",
    "supplier-groups.profile.number": "Number",
    "supplier-groups.profile.extension": "Extension",
    "supplier-groups.profile.add-phone": "Add Phone",
    "supplier-groups.button.cancel": "Cancel",
    "supplier-groups.button.submit": "Create",
    "suppliers.noresults.title": "No results found",
    "suppliers.noresults.subtitle":
      "We couldn’t find any channels matching your criteria.",
    "suppliers.button.add": "+ Assign Vendors",
    "suppliers.create.title": "Assign Vendors",
    "suppliers.button.clear": "Clear All",
    "suppliers.empty.title": "No vendors to display",
    "suppliers.empty.subtitle": "Start now assigning to a vendor by clicking",
    "suppliers.create_button": "New Vendor",
    "suppliers.input.name": "Name",
    "suppliers.input.code": "Code",
    "suppliers.button.cancel": "Cancel",
    "suppliers.button.submit": "Assign",
    "client.delete.successfully": "Client deleted successfully",
    "agency.delete.successfully": "Agency deleted successfully",
    "supplier.delete.successfully": "Supplier deleted successfully",
    "client.tabs.tags": "Fields",
    "supplier.profile.state": "State/Province",
    "agencies.list.region": "Region",
    "client.flow.levels.approversLastName.placeholder": "Type last name",
    "agency.edit.state": "State/Province",
    "client.profile.state": "State/Province",
    "campaign.daterange.apply": "Apply",
    "sort.name.asc": "Name",
    "inputs.phonetype.mobile": "Mobile",
    "inputs.phonetype.home": "Home",
    "plans.templates.cancel": "Cancel",
    "plan.preview.retry_prompt": "Want to try another file?",
    "agency.edit.city": "City",
    "agency.edit.director": "Managing Director",
    "client.documents.delete.confirm": "confirm",
    "admin.tabs.companies": "Companies",
    "client.profile.same_address": "Same as Billing Address",
    "campaign.documents.delete.cancel": "Cancel",
    "supplier.profile.select-media-types": "Select Media Types",
    "nav.dashboard": "Dashboards",
    "agencies.sort.updated.desc": "Updated Last",
    "plan.upload.submit": "View Details",
    "sort.updated.desc": "Updated Last",
    "plan.button.history": "Activity/History",
    "client.flow.approverLevels.name": "Level Name",
    "agency.edit.region": "Region",
    "customize.table.all": "All Columns",
    "plan.documents.view_all": "View all",
    "warning.modal.saving": "Saving",
    "plan.create.new_campaign.secondary": "Add to a new campaign",
    "client.flow.flags.mediaPlanAuthorization": "Media Plan",
    "client.teams.agency-client-code": "Agency Client Code",
    "customize.calendar.title": "Customize",
    "admin.i18n.upload": "Upload JSON",
    "supplier.profile.address1": "Address 1",
    "agencies.list.name": "Agency",
    "supplier.profile.address2": "Address 2",
    "campaign.documents.other": "Other",
    "client.flow.levels.approverLastName": "Approver's Last Name",
    "agency.button.cancel": "Cancel",
    "sort.created.asc": "Created First",
    "nav.plans": "Plans",
    "client.flow.flags.approvalCampaign": "Campaign",
    "client.button.update": "Update",
    "status.LIVE": "live",
    "campaigns.list.budget": "Planned Budget",
    "customize.calendar.progress": "Progress",
    "clients.empty.subtitle": "Start now assigning to a client by clicking",
    "supplier-groups.empty.subtitle":
      "Start now creating the first one by clicking",
    "agencies.list.country": "Country",
    "plan.documents.other": "Other",
    "client.flow.levels.approverFirstName": "Approver's First Name",
    "inputs.phonetype.business": "Business",
    "client.tabs.profile": "profile",

    "campaign.documents.brief": "Brief",
    "client.flow.flags.mediaTypeProductReAuthorization": "Product",
    "plan.dropzone.instructions.2":
      "Each cell should have a label in the first row of data indicating the type of information. This will be used for mapping to Halogen fields.",
    "plan.dropzone.instructions.1":
      "Each of your rows should represent one record",
    "plan.dropzone.instructions.4":
      "Your spreadsheet should not have empty columns that appear to the left of your first columns of data",
    "plan.dropzone.instructions.3": "Blank rows are not imported",
    "campaign.overview.audience": "Audience",
    "campaign.overview.target": "Target",
    "plan.dropzone.instructions.6":
      "Notes/Comments are not handled during import",
    "plan.dropzone.instructions.5": "Excel formulas are not imported",
    "customize.calendar.budget": "Budget",
    "customize.table.budget": "Budget",
    "campaign.create.title": "Create New Campaign",
    "agency.client.button.cancel": "Cancel",
    "client.tags.label": "Label",
    "plans.templates_button": "Templates",
    "agency.clients.button.add": "+ Assign Clients",
    "cannot.remove.client.config": "This client could not be deleted",
    "campaign.stats.empty.title": "No statistics to display yet",
    "plan.create.new_campaign.primary": "New Campaign",
    "agency.documents.add": "Add document",
    "agency.documents.logo": "Logo",
    "agency.documents.other": "Other",
    "agency.edit.address": "Business address",
    "agency.tabs.media-types": "Media Types",
    "client.flow.flags.campaignProductsReAuthorization": "Product",
    "clients.list.status": "Status",
    "campaign.overview.start": "Start Date",
    "plan.upload.success.subtitle": "Your file was parsed successfully.",
    "campaigns.list.start": "Start Date",
    "campaigns.list.campaign": "Campaign",
    "campaigns.list.number": "Number",
    "campaigns.list.product": "Product",
    "admin.i18n.or": "or",
    "agency.tabs.profile": "Profile",
    "client.profile.billing-contact": "Billing Contact",
    "agency.documents.type": "Document Type",
    "campaign.stats.empty.description":
      "No stats available yet. Once system pulls actualized spend, graph will be displayed.",
    "plan.button.approval": "Submit for approval",
    "document.required": "Document is required for approval",
    "campaign.audience.demographic": "Demographic",
    "client.flow.flags.mediaTypeDatesReApproval": "Start-End Date",
    "plan.create.existing_campaign.secondary": "Add to an existing campaign",
    "clients.noresults.title": "No clients to display",
    "client.profile.name": "Name",
    "plan.upload.again.prompt": "Ready to upload again?",
    "client.tabs.teams": "teams",
    "agency.edit.code": "Agency Code",
    "agency.documents.delete.prompt": "Delete File?",
    "customize.columns.mediaType": "Media Type Columns",
    "countries.list.tax_rate": "Tax Rate",
    "supplier.profile.city": "City",
    "supplier.region": "Region",
    "supplier.button.update": "Save",
    "plan.create.subtitle": "Start a new plan from scratch",
    "customize.table.button": "Customize",
    "warning.modal.save": "save",
    "status.COMPLETED": "completed",
    "plans.create_button": "+ New Media Plan",
    "plans.create_new_button": "New Media Plan",
    "plan.dropzone.prompt": "Drag & drop",
    "agencies.list.local_name": "Local Name",
    "agencies.list.status": "Status",
    "client.profile.phone": "Phone",
    "agency.client.create.title": "Assign Clients",
    "agency.media-types.empty": "no media types found",
    "client.flow.flags.mediaTypeBudgetReApproval": "Budget",
    "inputs.currencies.all": "All currencies",
    "plan.dropzone.incompatible.line2":
      "Please ensure that your file adheres to our",
    "plan.dropzone.incompatible.line1": "Unable to proceed.",
    "campaign.tabs.media_plans": "Media Plans",
    "plans.list.unpost.title": "Un-post Booking Order",
    "plans.list.unpost.description":
      "Are you sure you want to revert the post action on this Booking Order?",
    "plans.list.unpost.action": "Revert",
    "plan.button.unpost.bo": "Un-Post BO",
    "plans.list.unpost.items.title": "Un-post items",
    "plans.list.unpost.items.description":
      " Are you sure you want to revert the post action on the selected items?",
    "plans.button.unpost.items.title": "Un-post Line items",
    "spot.unmatch.modal.title": "Unmatch spot",
    "spot.unmatch.description":
      "Are you sure you want to unmatch the selected spot?",
    "modal.label.unmatch": "Unmatch",
    "plan.button.export": "Export Schedule(s)",
    "plan.button.split": "Split",
    "plan.button.export.atb": "Export ATB",
    "plan.button.export.digital": "Export Digital",
    "plan.button.deselect.all": "Deselect all",
    "plan.button.fetch.rankings": "Fetch Rankings",
    "plan.button.pre.evaluation": "Pre-Evaluation",
    "plan.button.optimize": "Optimize",
    "plan.button.apply.optimization": "Apply Optimization",
    "sort.name.desc": "Name (Reverse)",
    "clients.sort.created.desc": "Created Last",
    "customize.calendar.button": "Customize",
    "campaigns.list.budget_tracker": "Budget Tracker",
    "status.ARCHIVED": "archived",
    "agency.input.company": "Company Assigned",
    "client.tabs.products": "products",
    "products.list.delete.title": "Delete Channel",
    "products.list.delete.description":
      "Are you sure you want to delete the Rate Card?",
    "products.list.delete.action": "Delete",
    "new.product.assign": "+ New Vendor Product",
    "vendors.options.edit": "Edit",
    "vendors.options.delete": "Delete",
    "product.create": "Create Vendor Product",
    "products.name.input": "name",
    "clients.empty.title": "No clients to display",
    "product.update": "Update Vendor Product",
    "campaign.button.update": "Update",
    "supplier-groups.empty.title": "No supplier to display",
    "client.tags.global": "Global",
    "plan.documents.presentation": "Presentation",
    "plan.button.tryagain": "try again",
    "customize.calendar.light": "Light Mode",
    "warning.modal.cancel": "cancel",
    "agency.tabs.clients": "Clients",
    "customize.calendar.flight.booked": "Booked",
    "client.flow.levels.name": "Level Name",
    "checklist.type-for-more": "Type for more options",
    "admin.tabs.media_types": "Media Types",

    "client.flow.approval.by.client": "Approval Required By Client",
    "plans.list.status": "Status",
    "companies.list.code": "Code",
    "client.flow.levels.amount": "Amount Threshold",
    "client.flow.flags.mediaPlanProductReApproval": "Product",
    "campaigns.noresults.title": "No campaigns to display",
    "campaigns.create_new": "New Campaign",
    "campaigns.list.client": "Client",
    "agency.edit.localName": "Agency Local Name",
    "agency.documents.description.placeholder": "Add description (optional)",
    "nav.admin.others": "General",
    "companies.noresults.title": "No results found",
    "supplier-groups.noresults.title": "No vendor groups to display",
    "supplier-groups.add_new_subtitle": "New Vendor Group",
    "plan.create.or": "or",
    "client.profile.zip": "ZIP",
    "clients.create_button": "Assign Client",
    "client.tags.type": "Type",
    "campaign.button.cancel": "Cancel",
    "campaigns.sort.created.desc": "Created Last",
    "plan.upload.validation.failed.rows": "Row(s)",
    "supplier.local_name": "Local Name",
    "inputs.client": "Client",
    "inputs.product.label": "Product",
    "client.flow.flags.campaignProductReApproval": "Product",
    "client.flow.flags.campaignDatesReAuthorization": "Start-End Date",
    "supplier.documents.delete.cancel": "cancel",
    "plan.button.fullscreen": "Full screen",
    "client.flow.levels.title": "Levels",
    "campaign.activity.EDIT_CAMPAIGN": "Edited Campaign",
    "nav.team": "Team",
    "campaign.documents.add": "Add document",
    "client.unsaved-changes": "Unsaved Changes",
    "inputs.currency.placeholder": "Select Currency",
    "client.flow.levels.approversEmail.placeholder": "Type email",
    "status.ACTIVE": "active",
    "taxStatus.ACTIVE": "available",
    "taxStatus.INACTIVE": "unavailable",
    "plan.create.import.title": "Import a plan",
    "plan.create.mpl.title": "Import from Media Strategy",
    "plan.create.mpl.subtitle": "Import a scenario created in Media Strategy",
    "mpl.import.modal.title": "Import from Media Strategy",
    "mpl.import.modal.subtitle":
      "Please select from the below Media Strategy scenarios",
    "mpl.noresults.title": "No Media Strategy scenarios to display",
    "mpl.import.cancel": "Cancel",
    "mpl.import.submit": "Import",
    "mpl.list.scenario": "Scenario",
    "mpl.list.projectName": "Project Name",
    "mpl.list.startDate": "Start Date",
    "mpl.list.endDate": "End Date",
    "mpl.list.budget": "Budget",
    "mpl.list.client": "Client",
    "mpl.list.createdBy": "Created By",
    "customize.calendar.settings": "Display Settings",
    "client.flow.flags.campaignDatesReApproval": "Start-End Date",
    "plan.dropzone.instructions.preface":
      "Use the following guidelines to organize your Excel data for import",
    "plan.preview.label.found": "Found in file",
    "plans.noresults.subtitle":
      "We couldn’t find any plans matching your criteria.",
    "campaigns.list.budget_spent": "Booked",
    "campaigns.list.bookedItemsPercentage": "Booked Progress",
    "campaigns.list.invoiced": "Invoiced",
    "customize.table.title": "Customize",
    "agencies.list.core": "Code",
    "client.flow.flags.mediaPlanBudgetReAuthorization": "Budget",
    "plans.list.client": "Client",
    "plan.dropzone.instructions.title": "Import Guidelines",
    "supplier.tabs.profile": "Profile",
    "team.prompt": "Select the people in your team",
    "customize.calendar.grp": "GRPs",
    "client.tabs.documents": "documents",
    "client.tabs.channels": "channels",
    "supplier.channels.channelName": "Channel Name",
    "supplier.channels.mediaType": "Media Type",
    "supplier.channels.mediaSubtype": "Submedia type",
    "supplier.channels.noresults.title": "No results found",
    "supplier.channels.noresults.subtitle":
      "We couldn’t find any channels matching your criteria.",
    "agencies.noresults.title": "No agencies to display",
    "agencies.noresults.subtitle":
      "Start now assigning to an agency by clicking",
    "agencies.create_new": "Assign Agencies",
    "agencies.noresults.mediaSubType.title": "No Submedia types to display",
    "campaigns.sort.budget.asc": "Smallest Budget",
    "status.DRAFT": "Draft",
    "status.DEACTIVATED": "deactivate",
    "client.flow.flags.mediaPlanDatesReAuthorization": "Start-End Date",
    "client.flow.levels.approver": "Approver",
    "countries.noresults.subtitle":
      "We couldn’t find any countries matching your criteria.",
    "team.add_button": "Assign to Team",
    "document.button.cancel": "Cancel",
    "notifications.title": "Notifications",
    "nav.notifications": "Notifications",
    "client.teams.title": "Title",
    "high-importance": "High Importance",
    "follow-up": "Follow Up",
    "low-importance": "Low Importance",
    complete: "Complete",
    "clear-flag": "Clear Flag",
    "client.flow.levels.approversFirstName.placeholder": "Type first name",
    "client.flow.flags.authorizationLineItem": "Line Item",
    "campaign.overview.budget": "Total Budget",
    "client.profile.adress": "Address",
    "client.profile.ntype": "Number Type",

    "plan.timeunit.month": "Month",
    "plan.new.campaign.title": "Add new plan to…",
    "plan.new.actions.start": "start",
    "plan.new.actions.next": "next step",
    "plan.new.actions.save": "add",
    "plan.new.actions.skip": "skip",
    "plan.new.actions.previous": "previous step",
    "plan.new.details.title": "Add Media Plan Details…",
    "plan.new.details.name": "Μedia Plan Name",
    "plan.new.details.budget": "Μedia Plan Budget",
    "plan.new.details.startDate": "Media Plan Start Date",
    "plan.new.details.endDate": "Media Plan End Date",
    "plan.new.details.useCampaignDates": "Use the same dates with the campaign",
    "plan.new.details.useCampaignBudget":
      "Use the entire campaign’s budget for the plan",

    "media.plan.mpl.warning.prefix": "The Imported MPL Scenario contains an “",
    "media.plan.mpl.warning.suffix":
      "” that cannot be matched with a platform Media Type. Please update the client configuration accordingly.",
    "unmaped.channels.mpl.warning":
      "channels from MPL are unmapped. Please select another Media Type from the list below to replace it.",
    "submedia.types.mpl.warning":
      "The Imported MPL Scenario contains Submedia Types that cannot be matched with a platform Submedia Type.",

    "plan.new.mediatypes.title": "Select the Media Types for your Plan",
    "plan.new.mediatypes.subtitle":
      "You can always add / remove media types later",

    "plan.new.mediatypes.header.mediatype": "Media Type",
    "plan.new.mediatypes.header.budget": "Budget",
    "plan.new.mediatypes.placeholder.budget": "Budget",
    "plan.new.mediatypes.header.startEndDate": "Start-End Date",
    "plan.new.mediatypes.placeholder.selectDates": "Select Dates",

    "plan.new.mediatypes.header.subtype": "Submedia Type",
    "plan.new.mediatypes.addAnotherSubtype": "Add another Submedia Type",
    "plan.new.mediatypes.addSubtype": "Add Submedia Type",
    "plan.new.mediatypes.noSubtypes": "No Submedia Types yet",
    "plan.new.hide_subtypes": "Hide Submedia Types",
    "plan.new.show_subtypes": "View Submedia Types",

    "plan.new.targets.title": "Select the targets for your Plan",
    "plan.new.targets.placeholder.targetA": "Target A",
    "plan.new.targets.placeholder.targetB": "Target B",
    "plan.new.targets.addTarget": "+ New Target",
    "plan.new.targets.campaign.targets": "Same as Campaign's targets",

    "plan.new.actions.submitForApproval": "submit for approval",

    "supplier.save.success": "Supplier updated successfully",
    "agency.edit.zipCode": "Zip Code",
    "supplier.country": "Country",
    "customize.calendar.columns": "Columns",
    "plans.templates.client": "Client",
    "admin.i18n.browse": "browse",
    "campaign.objectives.placeholder": "Add campaign objectives here...",
    "inputs.product.placeholder": "Select Product",
    "nav.reports": "Reports",
    "client.local_name": "Legal Local Name",
    "campaigns.empty.title": "No campaigns to display",
    "document.uploading.title": "Uploading File",

    "campaign.copies": "Copies",
    "campaign.copies.noresults.title": "No Copies to display yet",
    "copies.modal.delete.title": "Remove Copy",
    "copies.modal.delete.description":
      "Are you sure you want to remove the Copy from the list?",
    "copy.delete.success": "Copy removed successfully",
    "copy.delete.error": "Error removing Copy",
    "copy.create_button": "+ Add Copy",
    "copy.create_button.empty.state": "Add a new Copy",
    "copies.noresults.title": "No Copies to display yet",
    "copies.list.name": "Name",
    "copies.list.productName": "Product",
    "copies.list.clientName": "Client",
    "copies.list.externalCode": "External Code",
    "copies.list.language": "Language",
    "copies.list.duration": "Duration",
    "copies.list.creativeAgencyId": "Creative Agency",
    "copies.list.copyQualityId": "Quality",
    "copies.list.mediaSemanticCode": "Media Type",
    "copies.list.mediaTypeSemanticCode": "Media Type",
    "copies.list.expDate": "Exp. Date",
    "copies.list.integrationStatus": "Integration Status",
    "copies.list.integrationDetails": "Integration details",
    "copies.modal.title1": "Add a Copy",
    "copies.modal.title2": "Create a Copy",
    "copies.modal.subtitle1":
      "Select an already created copy from the list below or add a new one",
    "copies.modal.subtitle2": "Fill in the fields to create a new copy",
    "copies.modal.copy": "Copy",
    "copies.modal.or": "or",
    "copies.modal.create.new": "Create a new copy",
    "copies.modal.codeUpdate.title": "Copy's external code",
    "copies.modal.codeUpdate.subtitle":
      "If you want to update the copy's external code, please write the new code below.",
    "copies.modal.codeUpdate.externalCode": "External code",
    "copies.modal.codeUpdate.errorMessage":
      "Code should be less than 32 characters long, no spaces allowed",
    "copies.modal.codeUpdate.cancel": "Cancel",
    "copies.modal.codeUpdate.update": "Update",
    "campaign.audience.apply": "Apply",
    "client.unsaved-message":
      "You have made changes. Do you want to save or discard them?",
    "supplier.profile.zip": "Zip Code",
    "plan.create.add": "Add plan to...",
    "plan.dropzone.description": "an .xlsx file here or",
    "plan.create.start": "Create New Media Plan",
    "plan.upload.validation.failed.title": "Validation Summary",
    "companies.list.region": "Region",
    "agency.edit.country": "Country",
    "clients.list.name": "Client",
    "client.documents.logo": "Logo",
    "client.documents.other": "Other",
    "clients.list.client-groups": "Client Group",
    "companies.noresults.subtitle":
      "We couldn’t find any companies matching your criteria.",
    "supplier-groups.noresults.subtitle":
      "Start now creating the first one by clicking",
    "filters.all": "All",
    "filters.country": "Country",
    "document.button.submit": "Upload",
    "campaigns.sort.end.desc": "Ends Last",
    "client.flow.reapproval.by.client": "Re-Approval Required By Client",
    "customize.calendar.chart": "Flight Indicators",
    "plan.preview.label.expected": "Selected label",
    "status.INACTIVE": "inactive",
    "plan.preview.title": "Column Mapping",
    "client.tags.actions": "Actions",
    "plan.documents.brief": "Brief",
    "plan.button.back": "Back",
    "client.profile.business-adress": "Bussiness Address",
    "client.flow.flags.campaignBankUsage": "Campaign Bank Usage",
    "client.flow.flags.requiresApproval": "Approval",
    "sort.created.desc": "Created Last",
    "campaigns.list.time_elapsed": "Time Elapsed",
    "agencies.sort.created.desc": "Created Last",
    "client.profile.city": "City",
    "customize.table.name": "Name",
    "companies.list.country": "Country",
    "client.profile.title": "Title",
    "customize.table.daypart": "Daypart",
    "client.flow.flags.mediaTypeDatesReAuthorization": "Start-End Date",
    "client.teams.team-lead": "Team Lead",
    "customize.columns.all": "All Columns",
    "inputs.tax_rate.placeholder": "Add Tax Rate",
    "field.isRequired": "This field is required",
    "field.validation.mixed.default": "This field is invalid",
    "field.validation.mixed.required": "This field is required",
    "field.validation.mixed.oneOf":
      "Must be one of the following values: ${values}",
    "field.validation.mixed.notOneOf":
      "Must not be one of the following values: ${values}",
    "field.validation.string.length": "Must be exactly ${length} characters",
    "field.validation.string.min": "Must be at least ${min} characters",
    "field.validation.string.max": "Must be at most ${max} characters",
    "field.validation.string.matches": "Must match the following: ${regex}",
    "field.validation.string.email": "Must be a valid email",
    "field.validation.string.url": "Must be a valid URL",
    "field.validation.string.trim": "Must be a trimmed string",
    "field.validation.string.lowercase": "Must be a lowercase string",
    "field.validation.string.uppercase": "Must be a upper case string",
    "field.validation.number.min": "Must be greater than or equal to ${min}",
    "field.validation.number.max": "Must be less than or equal to ${max}",
    "field.validation.number.lessThan": "Must be less than ${less}",
    "field.validation.number.moreThan": "Must be greater than ${more}",
    "field.validation.number.positive": "Must be a positive number",
    "field.validation.number.negative": "Must be a negative number",
    "field.validation.number.integer": "Must be an integer",
    "field.validation.date.min": "This field must be later than ${min}",
    "field.validation.date.max": "This field must be at earlier than ${max}",
    "field.validation.object.noUnknown":
      "This field has unspecified keys: ${unknown}",
    "field.validation.array.min": "This field must have at least ${min} items",
    "field.validation.array.max":
      "This field must have less than or equal to ${max} items",
    "field.should.not.be.empty": "Field value cannot be empty",
    "field.already.exists.in.db": "Agency code already exists",
    "campaign.input.budget": "Campaign Budget",
    "plan.import.subtitle": "Upload an .xlsx file with your plan ",
    "plan.import.title": "Import data from file",
    "plan.documents.description.placeholder": "Add description (optional)",
    "campaigns.sort.start.asc": "Starts First",
    "plan.dropzone.instructions.prompt": "import guidelines",
    "client.flow.flags.campaign": "Campaign",
    "plan.upload.validating.title": "Import data from file",
    "agency.tabs.documents": "Documents",
    "campaign.documents.description.placeholder": "Add description (optional)",
    "client.profile.billing-adress": "Billing Address",
    "client.flow.requirement.title": "Client requires",
    "clients.list.code": "Client code",
    "clients.list.companies": "Associated Companies",
    "clients.list.ipgCompany": "IPG Company",
    "campaigns.create_button": "+ New Campaign",
    "client.flow.flags.campaignApproval": "Campaign",
    "client.flow.flags.campaignBudgetReApproval": "Budget",
    "client.flow.flags.approvalMediaPlan": "Media Plan",
    "campaign.input.end": "End Date",
    "campaigns.budget_tracker": "Budget Tracker",
    "client.flow.approverLevels.approverLastName": "Approver's Last Name",
    "campaign.stats.actual_budget": "Actual Budget",
    "plans.empty.subtitle": "Start now creating the first one by clicking",
    "plans.media.empty.subtitle":
      "Start now creating the first one by clicking",
    "supplier.profile.country": "Country",
    "plan.upload.validation.failed": "Validation Summary",
    "client.flow.approverLevels.name.placeholder": "Type name",
    "checklist.more-options": "more options",
    "client.flow.authorization.by.client": "Authorization Required By Client",
    "filters.status": "Status",
    "filters.code": "Code",
    "filters.clientName": "Client Name",
    "filters.supplierName": "Supplier Name",
    "customize.calendar.indicators": "Actual Spend vs Forecast",
    "status.NEW": "new",
    "plans.list.start": "Start Date",
    "plan.documents.add": "Add creative",
    "plan.viewmode.table": "Table",
    "notifications.view_all": "View all",
    "campaign.button.submit": "Create",
    "inputs.region.placeholder": "Select Region",
    "campaign.description.prompt": "Add campaign description…",
    "campaign.overview.end": "End Date",
    "plan.timeunit.day": "Day",
    "client.profile.country": "Country",
    "client.flow.flags.mediaPlan": "Media Plan",
    "team.planners": "Planner(s)",
    "admin.tabs.suppliers": "Suppliers",
    "campaigns.sort.start.desc": "Starts Last",
    "campaigns.list.currency": "Currency",
    "client.flow.approverLevels.approversEmail.placeholder": "Type email",
    "plan.timeunit.week": "Week",
    "campaign.input.name": "Campaign Name",
    "plan.create.import.subtitle": "Import an existing plan",
    "client.profile.add-phone": "Add another Phone",
    "inputs.country.placeholder": "Select Country",
    "clients.noresults.subtitle":
      "Start now creating the first one by clicking",
    "inputs.search.placeholder": "Search...",
    "campaigns.noresults.subtitle":
      "Start now creating the first one by clicking",
    "client.fy": "FY",
    "companies.list.name": "Name",
    "nav.clients": "Clients",
    "client.flow.flags.mediaType": "Media Type",
    "plan.upload.validation.failed.subtitle":
      "Your file was parsed by the system and the errors shown below were found.",
    "clients.list.actions": "Actions",
    "status.AUTHORIZED": "authorized",
    "campaigns.list.end": "End Date",
    "countries.noresults.title": "No results found",
    "client.flow.levels.approverInfo": "Approver's info",
    "plan.button.save": "Save",
    "client.tags.name": "Name",
    "clients.sort.updated.desc": "Updated Last",
    "agency.lead.placeholder": "Select Team Lead",
    "agency.edit.address_line_1": "Address 1",
    "agencies.sort.created.asc": "Created First",
    "agency.edit.address_line_2": "Address 2",
    "inputs.currency": "Currency",
    "client.profile.email": "Email",
    "campaigns.list.actions": "Actions",
    "plan.create.name": "Media Plan Name",
    "agency.save.success": "Agency saved successfully",
    "client.flow.approverLevels.approverEmail": "Approver's Email",
    "plan.dropzone.instructions.line2":
      "This ensures that all data goes to the right place, but do not worry, all you have to do is map the column names/headers and your media plan will be ready.",
    "plan.dropzone.instructions.line1":
      "Please ensure you use the approved import template following the ",
    "agency.edit.lead": "Team Lead",
    "customize.calendar.dark": "Dark Mode",
    "plan.create.import.template.description":
      "Our platform has been optimized with the below import template.",
    "client.profile.addresses": "Addresses",
    "admin.i18n.title": "Labels",
    "campaign.button.activity": "Activity",
    "plan.create.submit": "Done",
    "campaign.documents": "Documents",
    "countries.list.currency": "Currency",
    "filters.mine": "Mine",
    "customize.columns.title": "Columns",
    "campaign.documents.presentation": "Presentation",
    "customize.columns.selected": "Selected Columns",
    "campaign.documents.delete.prompt": "Delete File?",
    "plans.list.time_elapsed": "Time Elapsed",
    "campaign.activity.CREATE_CAMPAIGN": "Created Campaign",
    "agency.director.placeholder": "Select Managing Director",
    "agency.edit.cancel": "Cancel",
    "plans.empty.title": "No Plans to display yet",
    "accordion.checkbox.enable": "Enable",
    "agency.create.title": "Add New Agency",
    "agency.assign.title": "Assign Agencies",
    "market-agency.assign.agencies": "Select Agencies to assign",
    "agency.button.clear": "Clear All",
    "agency.empty.title": "No agencies to display ",
    "agency.empty.subtitle": "Start now creating the first one by clicking",
    "agency.create_button": "Create New",
    "client.save.success": "Client updated successfully",
    "clients.sort.updated.asc": "Updated First",
    "filters.client": "Client",
    "campaign.documents.atb": "MBA",
    "campgaign.atb.modal.title": "Exported Media Plans",
    "campgaign.atb.modal.subtitle":
      "Please select the Media Plans that you want to be exported on the ATB.",
    "filters.region": "Region",
    "plan.documents.report": "Report",
    "customize.calendar.flight.actual": "Actual",
    "clients.sort.created.asc": "Created First",
    "admin.tabs.countries": "Countries",
    "plan.preview.subtitle":
      "Please use the selections below to map your column headers with our Halogen fields.",
    "plans.list.budget": "Budget (Local Currency)",
    "plans.list.budget_campaign_currency": "Budget (Foreign Currency)",
    "client.flow.levels.add": "Add another level",
    "plan.upload.title": "Here is a preview of your media plan",
    "client.profile.address1": "Address 1",
    "client.profile.address2": "Address 2",
    "inputs.sort_by": "Sort By",
    "plans.list.budget_spent": "Booked",
    "campaigns.list.status": "Status",
    "plan.documents.delete.confirm": "Delete",
    "campaign.objectives": "Objectives",
    "client.profile.extension": "Extension",
    "admin.i18n.collapse": "Hide list",
    "campaign.audience.invalid": "not applicable",
    "plan.button.cancel": "Cancel",
    "client.flow.flags.required": "Required",
    "client.teams.company": "Company",
    "account.login": "Log in",
    "account.logout": "Logout",
    "client.flow.flags.mediaPlanDatesReApproval": "Start-End Date",
    "document.upload.title": "File Upload",
    "agency.documents.delete.cancel": "Cancel",
    "plan.preview.mismatch":
      "Some columns do not match our template. Please fix all errors in order to proceed.",
    "client.flow.levels.name.placeholder": "Type name",

    "plan.table.empty.title": "No data to display",
    "plan.table.empty.subtitle":
      "Start now by selecting media type(s) or creating a package",
    "plan.table.header.name": "Name",
    "plan.table.header.mediaType": "Media Type",
    "plan.table.header.mediaSubtype": "Submedia Type",
    "plan.table.header.supplier": "Supplier",
    "plan.table.header.supplier_product": "Supplier Product",
    "plan.table.header.supplier_subproduct": "Sub Product",
    "plan.table.header.budget": "Budget",
    "plan.table.header.dayPartFrom": "Daypart (Start Time)",
    "plan.table.header.dayPartTo": "Daypart (End Time)",
    "plan.table.header.start": "Start Date",
    "plan.table.header.end": "End Date",
    "plan.table.header.volume": "Volume",
    "plan.table.header.baseCost": "Base Cost",
    "plan.table.header.baseRate": "Base Rate",
    "plan.table.header.description": "Description",
    "plan.table.header.status": "Status",
    "plan.table.header.weekParts": "Weekparts",
    "plan.table.header.clientDiscount": "Client Discount",
    "plan.table.line.add.empty": "Empty row",
    "plan.table.line.add.duplicate": "Duplicate selected row",
    "plan.table.line.add.rows": "Rows",
    "plan.table.line.add.button": "Add",
    "plan.table.line.add.select.category": "Select category to add",
    "plan.table.line.add.mediaType": "Media Type",
    "plan.table.line.add.mediaSubType": "Submedia type",
    "plan.table.line.add.lineItem": "Line Item",
    "plan.table.line.add.rankingItem": "Ranking Item",
    "plan.table.line.add.package": "Package",
    "plan.table.submediatype.line.add.empty": "Submedia type",
    "media.plan.save.error": "The media plan could not be saved :-/",
    "media.plan.save.success": "The media plan is updated successfully!",
    "approve.modal.approve": "Approve",
    "client.approver": "Client Approver",
    "date.of.approval": "Date of Approval",
    "add.comment": "Add comment (optional)",
    "add.comment.required": "Add comment",
    "status.PENDING": "Pending",
    "status.PENDING_CHANGE_REQUEST": "Pending CR Approval",
    "campaign.approve": "Approve",
    "campaign.submit.success": "Campaign submitted for approval",
    "campaign.submit.error": "Something went wrong in submitting the campaign",
    "actions.delete": "Delete",
    "actions.remove": "Remove",
    "comment.modal.title": "Reject",
    "campaign.dont-approve": "Reject",
    "comment.modal.add-comment": "Reject",
    "add.campaign-comment": "Add comment",
    "campaign.is.pending.approval": "This Campaign is pending approval",
    "campaign.documents.logo": "Logo",
    "campaign.documents.terms": "Terms & Conditions",
    "suppliers.list.name": "Vendor",
    "suppliers.list.local_name": "Local Name",
    "suppliers.list.code": "Code",
    "suppliers.list.region": "Region",
    "suppliers.list.country": "Country",
    "suppliers.list.agency": "Agency",
    "suppliers.list.status": "Status",
    "supplier.options.activate": "Activate",
    "supplier.options.deactivate": "Deactivate",
    "supplier.modal.activate.title": "Activate Supplier",
    "supplier.modal.activate.description":
      "Are you sure you want to activate this supplier?",
    "modal.label.deactivate": "Deactivate",
    "supplier.modal.deactivate.title": "Deactivate Supplier",
    "supplier.modal.deactivate.description":
      "Are you sure you want to deactivate this supplier?",

    "media.table.select.media": "Add Media Type",
    "media.table.select.more.media": "Add more media type(s) to your plan",
    "media.table.new.media.type": "Media Type",
    "media.table.new.submedia.type": "Submedia Type",
    "media.table.new.media.budget": "Budget",
    "media.table.new.media.startDate": "Start Date",
    "media.table.new.media.endDate": "End Date",
    "media.table.new.media.select.budget": "Budget",

    "media.table.new.media.all.medias.used":
      "All media types have already been used",
    "media.table.new.media.add.subtype": "Add a Submedia type",
    "media.table.new.media.select.subtype": "Select Submedia type",
    "media.table.new.media.submit": "Done",
    "media.table.new.submission.error":
      "The new media type could not be added. Please make sure that you have filled in all type, budget and date fields and try again",
    "media.plan.submit.error": "The Media Plan could not be submitted.",
    "media.plan.submit.success":
      "The Media Plan has been submitted for approval.",
    "media.plan.validate.success": "The Media Plan validated successfully",
    "media.plan.validate.error": "The Media Plan could not be validated",
    "confirmation.dialog.cancel": "Cancel",
    "confirmation.dialog.submit": "Submit",
    "agency.options.activate": "Activate",
    "agency.modal.activate.title": "Activate agency",
    "agency.modal.activate.description":
      "Are you sure you want to activate this agency?",
    "agency.options.delete": "Delete",
    "agency.modal.delete.title": "Delete agency",
    "agency.modal.delete.description":
      "Are you sure you want to delete this agency?",
    "clients.modal.activate.title": "Activate client",
    "clients.modal.activate.description":
      "Are you sure you want to activate this client?",
    "supplier.modal.delete.title": "Delete Vendor",
    "supplier.modal.delete.description":
      "Are you sure you want to delete this vendor?",
    "clients.modal.delete.title": "Delete client",
    "clients.modal.delete.description":
      "Are you sure you want to delete this client?",

    "plan.button.version": "Plan Version",
    "plan.version.history.title": "Version History",
    "plan.version.history.UPDATE": "Updated",
    "plan.version.history.CREATE": "Created",
    "create.plan.from.version": "create new plan from this version",
    "plan.version.history.current": "current version",
    "plan.version.history.what.changed": "What has changed?",
    "plan.version.history.give.description": "Give a description",
    "plan.version.history.post": "Post",

    "bo.button.version": "Booking Order Version",
    "bo.version.history.title": "Version History",
    "bo.version.history.UPDATE": "Updated",
    "bo.version.history.CREATE": "Created",
    "create.bo.from.version": "create new booking order from this version",
    "bo.version.history.current": "current version",
    "bo.version.history.what.changed": "What has changed?",
    "bo.version.history.give.description": "Give a description",
    "bo.version.history.post": "Post",

    "campain.details.delete": "Delete ",
    "campain.list.delete": "Delete",
    "campaign.modal.delete.title": "Delete Campaign",
    "campaign.modal.delete.description":
      "Are you sure you want to delete this campaign?",

    "agency.edit.commission": "Agency Commission",
    "client.details.costs-category": "Costs Categories",
    "client.details.fees.enter-name": "Add name",
    "client.details.fees.enter-rate": "Add rate",
    "client.details.fees.levels.amount": "Rate",
    "client.details.fees.levels.name": "Name",
    "client.fees.add-another-fee": "Add another fee",
    "client.tabs.costs": "Fees",
    "campain.list.archive": "Archive",
    "modal.label.delete": "Delete",
    "modal.label.cancel": "Cancel",
    "campaign.modal.archive.title": "Archive Campaign",
    "campaign.modal.archive.description":
      "Are you sure you want to archive this campaign?",
    "modal.label.activate": "Activate",

    "modal.label.archive": "Archive",

    "campaign.details.delete": "Delete",
    "campaign.details.archive": "Archive",

    "error.unknown": "Something went wrong!",
    "error.field.required": "This field is required",
    "login.wrong_credentials": "Wrong credentials",
    "client.tabs.contacts": "Contacts",
    "contacts.noresults.title": "No results found",
    "contacts.noresults.subtitle":
      "We couldn’t find any contacts matching your criteria.",
    "contacts.list.first_name": "First Name",
    "contacts.list.last_name": "Last Name",
    "contacts.list.position": "Position",
    "contacts.list.email": "Email",
    "contacts.list.phone_number": "Phone Number",
    "contacts.list.phone_type": "Phone Type",
    "contacts.list.address": "Address",
    "nav.planning-dashboard": "Planning",
    "nav.buying-billing-dashboard": "Buying / Billing",
    "nav.regional-dashboard": "Regional",

    "buying-billing-dashboard.client-summary.filter": "Client Summary",
    "buying-billing-dashboard.media-type.filter": "Media Type",
    "buying-billing-dashboard.client.filter": "Client",
    "buying-billing-dashboard.supplier.filter": "Supplier",
    "buying-billing-dashboard.date.filter": "Date",

    "dashboard.filters.media.plans": "Media Plans",
    "dashboard.filters.campaigns": "Campaigns",
    "dashboard.filters.mediatypeplan": "Media Type",
    "dashboard.filters.entityType": "Entity Type",
    "dashboard.filters.eventType.APPROVE": "Budget Approved",
    "dashboard.filters.eventType.INCREASE": "Budget Increased",
    "dashboard.filters.eventType.DECREASE": "Budget Decreased",
    "dashboard.filters.eventType.mediaType.INCREASE":
      "Media Type Budget Increased",
    "dashboard.filters.eventType.mediaType.DECREASE":
      "Media Type Budget Decreased",

    "plan.table.header.total": "Total",
    "plan.table.line.add.media_type_plan": "Media Type",
    "plan.table.line.add.media_subtype_plan": "Submedia type",
    "plan.table.line.add.line_item": "Line Item",
    "plan.table.line.add.ranking_item": "Ranking Item",

    "campaign.approve.cr": "Approve Request",
    "campaign.approved.cr.successfully":
      "Campaign change request approved successfully",
    "campaign.rejected.cr.successfully":
      "Campaign change request rejected successfully",
    "campaign.archived.success": "Campaign archived successfully",
    "campaign.archived.error": "Error archiving Campaign",
    "campaign.delete.success": "Campaign deleted successfully",
    "campaign.delete.error": "Error deleting Campaign",
    "campaign.create.change.request": "Change Request",
    "campaign.create.export.atb": "Export ATB",
    "campaign.cr.discard.success": "Change request discarded successfully",
    "campaign.cr.title.on.approve":
      "There have been mDeactivateade changes in Campaign and Media PlanName",
    "campaign.cr.title.on.update":
      "Change request is in progress, no further modifications allowed until approved",
    "campaign.cr.title.on.submit":
      "There have been made changes in Campaign and Media PlanName. ",
    "campaign.cr.requested.change": "Requested Change",
    "error.campaign.notFound": "Campaign not found.",
    "campaign.modal.discard.cr.title": "Discard",
    "campaign.modal.submit.cr.title": "Submit change  request",
    "campaign.submit.change.request": "Submit",
    "campaign.submit.cr": "submit",
    "campaign.update.cr": "Update",
    "plan.cr.name.not.editable":
      "Name cannot be edited because Media Plan has posted BOs",
    "campaign.cr.name.not.editable":
      "Name cannot be edited because Campaign's Media Plans have posted BOs",
    "discard.request": "Discard request",
    "modal.discard": "Discard",
    "modal.submit": "Submit",
    "save.changes": "Save changes",
    "view.changes": "View changes",

    "plan.table.error.required": "This field is required",
    "plan.table.error.budget.exceeded":
      "The budget is less than the planned cost",
    "plan.table.error.date.after":
      "The date is after the earliest planned item",
    "plan.table.error.date.before":
      "The date is before the latest planned item",
    "approve.request": "Approve Request",
    "campaign.cr.approve.request": "Approve Request",
    "campaign.cr.reject.request": "Reject Request",
    "reject.request": "Reject Request",
    "missing.comment.field": "Field is required",
    "submit.request": "Submit Request",
    "campaign.cr.submit.request": "Submit Request",
    "modal.discard.request": "Discard",
    "campaign.modal.discard.cr.description":
      "Changes have been made. Please confirm you’d like to discard all changes up to now.",
    "campaign.modal.submit.cr.description":
      "Are you sure you want to submit change request?",

    "submit.cr": "Submit Change Request",

    "clients.modal.deactivate.description":
      "Are you sure you want to deactivate this client?",
    "clients.modal.deactivate.title": "Deactivate Client",
    "agency.options.deactivate": "Deactivate",

    "agency.modal.deactivate.title": "Deactivate Agency",
    "agency.modal.deactivate.description":
      "Are you sure you want to deactivate this agency?",

    "int.client-bank": "Client Bank",
    "int.total-in-amount": "Total campaign amount",
    "int.campaign": "Campaign",
    "int.available-bank": "Available Bank",
    bank: "Bank",
    "int.campaign-total-bank": "Available Bank",
    "int.total-amount-transfer-title": "Total amount to transfer",
    transfer: "Transfer",

    "plan.button.delete": "Delete",
    "no.documents": "No documents to display",
    "no.documents.subtitle": "Start now creating the first one by clicking",
    "no.search.results": "No search results",
    "no-available-options": "no available options",

    "plans.list.copy.title": "Copy Media Plan",
    "plans.list.copy.description":
      "Are you sure you want to crate a copy of this Media Plan?",
    "copy.action": "Copy",

    "plans.create.change.request": "Create Change Request",
    "change.request.flowPlanItems":
      "There are changes in the media plan line items. You can review those in the media plan table should you like to.",
    "change.request.name": "Name",
    "change.request.budget": "Budget",
    "change.request.exchangeRate": "Exchange Rate",
    "change.request.currencyExchangeRate": "Exchange Rate",
    "change.request.start": "Start Date",
    "change.request.end": "End Date",
    "campaign.cr.saved": "The change request has been saved successfully",
    "plan.cr.saved": "The change request has been saved successfully",
    "plan.cr.saved.error": "The change request could not be saved",

    "error.tag.is.duplicate": "Duplicate tag entry",
    "no.media.types.enabled":
      "At least one media type should be activated to access this screen",
    "status.AWAITING_DELETE": "Draft",
    "line.items.details": "Line Item Details",

    "dashboard.empty.graph.title": "no data to display yet",
    "dashboard.graph.curently.unavailable": "Currently unavailable",
    "nav.regional": "APAC Regional Dashboard",
    "nav.buying.billing": "Buying - Billing",
    "nav.planning": "Planning",
    add: "Add",
    cancel: "Cancel",
    "estimate.id": "EstimateID",
    estimateId: "EstimateID",
    "estimate.id.view": "View",
    "media.type": "Media Type",
    "plans.add.estimate.id": "Add Estimate ID",
    "plans.edit.estimate.id": "Edit Estimate ID",
    "plans.need.estimate.id":
      "You need to add EstimateID before media plan activation",
    "update.estimates.id.fail": "Duplicate EstimateId",
    "activate.plan.fail": "Plan failed to activate",
    "save.and.activate": "Save & Activate",

    "plan.details.period": "Plan Period",
    "plan.details.budget": "Budget",
    "plan.details.number": "Number",
    "plan.details.kpis": "KPIs",
    "plan.details.summary": "Financial Summary",
    "plan.details.summary.totalMediaGrossCost": "Total Gross",
    "plan.details.summary.totalMediaCommissions": "Total Media Commissions",
    "plan.details.summary.totalMediaNetCost": "Total Net",
    "plan.details.summary.totalCosts": "Total Costs",
    "plan.details.summary.totalAgencyFees": "Total Agency Fees",
    "plan.details.summary.totalMediaFees": "Total Media Fees",
    "plan.details.summary.totalAgencyCommissions": "Total Agency Commissions",
    "totalAgencyCommissions.PRODUCTION": "AC Production Cost",
    "totalAgencyCommissions.GROSS": "AC Rate (Gross)",
    "totalAgencyCommissions.NET": "AC Rate (Net)",
    "totalMediaCommissions.PRODUCTION": "MC Production Cost",
    "totalMediaCommissions.GROSS": "MC Rate (Gross)",
    "totalMediaCommissions.NET": "MC Rate (Net)",
    "totalFees.PRODUCTION": "Production Cost",
    "totalFees.MANAGEMENT": "Management Cost",
    "totalFees.BOOKING": "Booking Cost",
    "totalFees.TALENT": "Talent Cost",
    "totalFees.RETAINER": "Retainer Cost",
    "totalFees.PLANNING": "Planning Cost",
    "totalFees.OTHERS": "Other Cost",
    "totalMediaFees.PRODUCTION": "Passthrough Costs",
    "totalAgencyFees.MANAGEMENT": "Management",
    "totalAgencyFees.BOOKING": "Booking",
    "totalAgencyFees.TALENT": "Talent",
    "totalAgencyFees.RETAINER": "Retainer",
    "totalAgencyFees.PLANNING": "Planning",
    "totalAgencyFees.OTHERS": "Other",
    "plan.details.summary.totalTaxes": "Total Taxes",
    "plan.details.summary.totalBillable": "Net Payable",
    "plan.details.version": "Version",
    "plan.details.estimateId": "EstimateID",
    "plan.official": "Mark as Official",
    "plan.modal.official.action": "Yes, Mark",
    "plan.modal.official.title": "Mark as official",
    "plan.modal.official.description":
      "Are you sure you want to mark this Media Plan as official?",
    "plan.details.display.version": "Display Version",
    "plan.details.official.version": "Official Version",
    "plan.details.official.version.based.on": "Based on Display V",
    "plan.grid.flowplan.view": "Flowplan",
    planned: "Planned",
    "plan.campaign.info.budget": "Budget",
    "plan.campaign.info.client": "Client",
    "plan.campaign.info.brief": "Brief",
    "plan.campaign.info.product": "Product",
    "plan.campaign.info.plans": "Media Plans",
    "plan.campaign.info.dates": "Dates",
    "plan.campaign.info.current": "Current View",

    "campaign.details.client": "Client",
    "campaign.details.agency": "Agency",
    "campaign.details.number": "Number",
    "clients.list.agency": "Agency",
    "campaign.details.product": "Product",
    "campaign.details.ponumber": "PO Number",
    "campaign.details.budget": "Budget",
    "start.date.should.be.before.end.date":
      "Start date should be before end date",

    "role.ADMINISTRATOR": "Admin",
    "role.MANAGING_DIRECTOR": "Managing Director",
    "role.TEAM_LEAD": "Team Lead",
    "role.PLANNER": "Planner",
    "role.CLIENT": "Client",
    "role.GLOBAL_ADMINISTRATOR": "Global Admin",
    "role.GLOBAL_FINANCE": "Global Finance",
    "role.MARKET_ADMINISTRATOR": "Market Admin",
    "role.MARKET_FINANCE": "Market Finance",
    "role.AGENCY_ADMINISTRATOR": "Agency Admin",
    "role.REGIONAL_FINANCE": "Regional Finance",

    "agencies.team.emptyState.title": "No team to display",
    "options.none": "None",
    "options.any": "Any",

    "plan.table.header.supplierId": "Supplier",
    "plan.table.header.supplierProductId": "Supplier Product",
    "plan.table.header.supplierSubProductName": "Sub Product",
    "plan.table.header.startDate": "Start Date",
    "plan.table.header.endDate": "End Date",
    "customizer.exit": "Exit",
    "customizer.save": "Save and exit",

    "sidebar.link.FAQ": "FAQ",
    "sidebar.link.user.guide": "User Guide",
    "sidebar.link.service.desk": "Service Desk",
    "mediaplan.tabs.overview": "Overview",
    "mediaplan.tabs.flowchart": "Flowchart",
    "mediaplan.tabs.table": "Table",
    "mediaplan.tabs.bookingOrders": "Booking Orders",

    "mediaplan.overview.budget": "Budget",
    "mediaplan.overview.grossBudget": "Gross Budget",
    "mediaplan.overview.actualSpend": "Actual Spend",
    "mediaplan.overview.remaining": "Remaining",
    "mediaplan.overview.planPeriod": "Plan Period",
    "mediaplan.overview.days.untill.start": "Days untill start",
    "mediaplan.overview.campaign.details": "Campaign Details",
    "mediaplan.overview.campaign.view.more": "View more",
    "mediaplan.overview.campaign.name": "Name",
    "mediaplan.overview.campaign.number": "Number",
    "mediaplan.overview.campaign.budget": "Budget",
    "mediaplan.overview.campaign.status": "Status",
    "mediaplan.overview.campaign.period": "Period",
    "mediaplan.overview.campaign.client": "Client",
    "mediaplan.overview.campaign.agency": "Agency",
    "mediaplan.overview.campaign.plans": "Media Plans",
    "mediaplan.overview.scenario": "MPL Scenario",
    "mediaplan.overview.activity": "Activity",
    "mediaplan.overview.financial": "Financial Summary",
    "mediaplan.overview.kpis": "KPIs",
    "mediaplan.kpi.add_button": "Add Client Brief KPIs",
    "mediaplan.kpi.edit_button": "Edit Client Brief KPIs",
    "mediaplan.kpis.noresults.title": "No KPIs to display yet",
    "mediaplan.kpis.noresults.subtitle":
      "Add KPIs from Client Brief and start building your Media Plan to evaluate its impact",
    "mediaplan.kpis.create_button.empty.state": "Add Client Brief KPIs",
    "mediaplan.kpis.create_button.noSubmedias":
      "There are no Submedia Types available in order to create Client Brief KPIs.",
    "kpi.list.name": "KPI",
    "kpi.list.brief": "Client Brief",
    "kpi.list.preEvaluation": "Pre-Evaluation",
    "kpi.list.postEvaluation": "Post-Evaluation",
    "kpi.modal.add": "Add KPIs",
    "kpi.modal.edit": "Edit KPIs",
    "kpi.modal.subtitle": "Set the KPIs as received from Client Brief",
    "kpi.modal.submedias": "Submedia Type",
    "kpi.modal.select.kpis": "Select KPIs",
    "kpi.modal.noresults": "No KPIs selected yet",
    "kpi.modal.all": "All",
    "kpi.modal.title.clientBrief": "Client Brief",
    "kpi.modal.title.pre.eval": "Pre-evaluation",
    "kpi.modal.title.post.eval": "Post-evaluation",
    "mediaplan.alert.errors":
      "The media plan could not be submitted due to errors.",
    "mediaplan.line.errors": "There are lines with errors",
    "mediaplan.show.errors.only": "Show only lines with errors",

    "mediaplan.export.title": "Export Media Plan",
    "mediaplan.reimport.title": "Import Media Plan",
    "mediaplan.reimport.subtitle":
      "By importing a new file, data will be updated  and a new version of the plan will be created.",
    "mediaplan.reimport.close": "Close",
    "plans.import.new": "Reimport Schedule(s)",
    "mediaplan.delete.title":
      "Are you sure you want to delete the selected Items?",
    "mediaplan.delete.subtitle":
      "Once this Change Request is approved, the selected items will be permanently removed from the Media Plan. Any budget allocated to these items will be released for future use.",
    "mediaplan.delete.note.first":
      "Please note that some of the selected Line Items",
    "mediaplan.delete.note.bold": " cannot be deleted",
    "mediaplan.delete.note.second":
      " as they are already used in a Booking Order or they are under Change Request. These Line Items will be excluded from deletion.",
    "mediaplan.delete.cancel": "Cancel",
    "mediaplan.delete.submit": "Delete",
    "droparea.title": "Drag & drop",
    "droparea.documents": "Documents",
    "droparea.here.or": "here or",
    "droparea.browse": "browse",
    "droparea.isDragAccept": "Drop your file here...",
    "droparea.unsupported.file":
      "Invalid file format. Please make sure your file is valid and try again.",

    "supplier.documents.description": "documents",
    "agency.documents.description": "documents",
    "client.documents.description": "documents",
    "suppliergroups.documents.description": "documents",
    "suppliergroups.documents.logo": "Logo",
    "suppliergroups.documents.other": "Other",
    "campaign.documents.description": "brief / documents",
    "plan.documents.description": "creatives",
    "approve.modal.documents.label": "Authorization to Buy document",

    "cr.submit.success": "Change request submitted successfully",
    "cr.submit.error": "Error submitting change request",
    "campaign.overview.approvers": "Approvers",
    "campaign.overview.approvers.empty": "no approvers",

    "bulk.editor": "Bulk Editor",
    "bulk.editor.apply": "Apply to all",
    "bulk.editor.note": "The above values will apply to all visible rows",

    "item.delete.title": "Delete Media Type",
    "item.delete.description":
      "Are your sure that you want to delete this Media Type?",
    "add.version.comment": "Add comment",

    "plans.list.export.action": "Save and Export",
    "plans.list.submit.action": "Save and Submit",
    "plans.list.proceed.action": "Save and Proceed",
    "plans.list.bulk.proceed.action": "Proceed with changes and save",
    "unsaved.plan.title": "Unsaved changes",
    "unsaved.plan.description":
      "The media plan has unsaved changes. Do you wish to save those first in order to proceed?",
    "unsaved.plan.bulk.description":
      "You have chosen to update a number of line items at once. That action will save the updated plan and increment it's version. Are you sure that you want to proceed?",
    "approve.message": "You have successfully approved the ",
    "approve.submessage": "Our team will now proceed.",
    "reject.message": "You have rejected the ",
    "reject.submessage.part1": "An updated",
    "reject.submessage.part2": "will be resubmitted.",

    "date.range.filter.placeholder": "Date range",
    "nav.admin.media-types": "Media Types",
    "nav.admin.media-fields": "Fields",
    "admin.mediaTypes.create_button": "+ New Media Type",
    "admin.mediaTypes.create_new": "New Media Type",
    "admin.mediaFields.add_new": "+ New Field",
    "admin.mediaFields.add_new_subtitle": "New Field",
    "admin.mediaFields.field.create_button": "Create New",
    "admin.mediaFields.field.or": "or",
    "admin.mediaTypes.subMediaTypes": "SubMedia Types",
    "admin.mediaTypes.fields": "Fields",
    "button.add": "add",
    "button.view": "view",
    "select-all": "Select All",
    "admin.mediaTypes.new.mediaType": "New Media Type",
    "admin.mediaTypes.edit.mediaType": "Edit Media Type",
    "admin.mediaTypes.tabs.genral": "General Info",
    "admin.mediaTypes.tabs.submedia": "Submedia Types",
    "admin.mediaTypes.tabs.fields": "Fields",
    "admin.mediaTypes.tabs.vendorProducts": "Vendor Products",
    "admin.mediaTypes.vendorProducts": "Vendor Products",
    "admin.mediaTypes.vendorProducts.empty": "No Vendor Products",
    "admin.mediaTypes.semantic": "Semantic",
    "admin.mediaTypes.type": "Type",
    "admin.mediaTypes.category": "Category",
    "admin.mediaTypes.label": "Label",
    "admin.mediaTypes.color": "Color",
    "admin.mediaTypes.rateCard": "Rate Card",
    "admin.mediaTypes.rateCard.enabled": "Enabled",
    "admin.mediaTypes.rateCard.disabled": "Disabled",
    "admin.mediaTypes.actions": "Actions",
    "admin.mediaTypes.submedia.select": "Select Submedia Types",
    "admin.mediaTypes.fields.select": "Select Field Types",
    "admin.mediaTypes.color.reset": "Reset to default",
    "admin.mediaType.delete.title": "Delete Media Type",
    "admin.mediaType.delete.description":
      "Are you sure you want to delete this Media Type?",
    "admin.mediaType.delete.action": "Delete",
    "admin.submediaType.delete.title": "Delete Submedia Type",
    "admin.submediaType.delete.description":
      "Are you sure you want to delete this Submedia Type?",
    "admin.submediaType.delete.action": "Delete",
    "admin.submediaType.add": "Submedia",
    "admin.submediaType.add.placeholder": "Select Submedia Type to add...",
    "admin.fields.delete.title": "Delete Field",
    "admin.fields.delete.description":
      "Are you sure you want to delete this Field?",
    "admin.fields.delete.action": "Delete",
    "admin.mediaType.fields.remove.title": "Remove Field",
    "admin.mediaType.fields.remove.description":
      "Are you sure you want to remove this Field from the Media Type?",
    "admin.mediaType.fields.remove.action": "Delete",
    "admin.mediaFields.create.title": "Create New Field",
    "admin.mediaFields.create.submit": "Create",
    "admin.mediaFields.field.add": "Select Field",
    "admin.mediaFields.field.add.placeholder": "Select Field to add...",
    "admin.mediaFields.field.add.label": "Field",
    "admin.mediaFields.field.add.label.placeholder": "Add name...",
    "admin.mediaFields.semantic": "Semantic",
    "admin.mediaFields.label": "Label",
    "admin.mediaFields.calculation": "Calculation",
    "admin.mediaFields.type": "Type",
    "admin.mediaFields.type.addList": "Add List",
    "admin.mediaFields.type.viewList": "View List",
    "admin.mediaFields.type.addList.title": "List Of Options",
    "admin.mediaFields.type.addList.add": "Add Another Option",
    "admin.mediaFields.type.addList.label": "Add Option",
    "admin.mediaFields.type.addList.option": "Option",
    "admin.mediaFields.type.addList.placeholder": "Add Option",
    "admin.mediaFields.type.addList.apply": "Apply",
    "admin.mediaFields.category": "Category",
    "admin.mediaFields.mediaTypes.add": "add Media Types",
    "admin.mediaFields.mediaTypes.more": "more",
    "admin.mediaFields.validation.success":
      "The following formula was successfully validated!",
    "admin.mediaFields.validation.error": "Error validating formulas!",
    "admin.mediaFields.calculated.apply": "Apply",
    "admin.mediaFields.calculated.validate": "Validate Formula",
    "admin.mediaFields.calculated.attribute": "Attribute",
    "admin.mediaFields.calculated.operation": "Operation",
    "admin.mediaFields.calculated.operation.+": "Add (+)",
    "admin.mediaFields.calculated.operation./": "Divide (/)",
    "admin.mediaFields.calculated.operation.*": "Multiply (*)",
    "admin.mediaFields.calculated.operation.-": "Subtract (-)",
    "admin.mediaFields.calculated.add.part": "+ Add part",
    "admin.mediaFields.calculated.add.operation": "+ Add operation",
    "admin.mediaFields.calculated.viewFormula": "View Formula",
    "admin.mediaFields.calculated.addFormula": "Add Formula",
    "admin.mediaFields.calculated.mediaFieldId": "Media Field Id",
    "admin.mediaFields.calculated.fixedValue": "Fixed Value",
    "admin.mediaTypes.empty.title": "No Media Types to display",
    "admin.mediaTypes.empty.subtitle":
      "Start now creating the first one by clicking",
    "admin.mediaTypes.create.submit": "Create",
    "filters.fieldType": "Type",
    "filters.fieldCategory": "Category",
    "filters.fieldMediaTypes": "Media Types",
    "add.new.media": "+ Add Media Type",
    "market.modal.delete.title": "Delete Market",
    "market.modal.delete.description":
      "Are you sure you want to delete this Market?",
    "calculation.formula": "Calculation Formula",
    "subregion.button.new.market": "+ New Market",
    "subregion.empty.market": "No Markets assigned to this Sub-Region yet",
    "subregion.empty.add.market": "Add Market",
    "subregion.modal.delete.title": "Delete SubRegion",
    "subregion.modal.delete.description":
      "Are you sure you want to delete this SubRegion?",
    "market-admin.agencies.list.delete.action": "Delete",
    "market-admin.agencies.list.delete.title": "Delete Agency",
    "market-admin.agencies.list.delete.description":
      "Are you sure you want to delete this Agency?",
    "market-agency.create.button": "New Agency",
    "market-agencies.profile.details": "Details",
    "market-agencies.profile.contact": "Contact Details",
    "market-agencies.profile.contact.subtitle":
      "Select which Phone and Fax Number you want to be printed on the official documents.",
    "market-agencies.profile.no.phones": "No phone number added yet.",
    "market-agencies.profile.no.faxes": "No fax number added yet.",
    "market-agencies.profile.phones": "Phone Number",
    "market-agencies.profile.add-phones": "Add Phone Number",
    "market-agencies.profile.faxes": "Fax Number",
    "market-agencies.profile.add-faxes": "Add Fax Number",
    "market-agencies.profile.contact.phones.number.empty":
      "The default phone number should not be empty",
    "market-agencies.profile.contact.faxes.number.empty":
      "The default fax number should not be empty",
    "market-agency.companies.create.title": "Assign to Companies",
    "market-agency.assign.companies": "Select Companies to assign to",
    "market-agency.vendor.create.title": "Assign Vendor",
    "market-agency.assign.vendors": "Select Vendor to assign",
    "filter.by.vendor": "Vendor",
    "filter.by.product": "Vendor Product",
    "client-groups.noresults.title": "No client groups to display",
    "client-groups.noresults.subtitle":
      "Start now creating the first one by clicking",
    "client-groups.add_new_subtitle": "New Client Group",
    "company.noresults.title": "No companies to display",
    "company.noresults.subtitle":
      "Start now assigning to a company by clicking",
    "company.add_button": "Assign to Companies",
    "media.fields.noresults.title": "No fields to display",
    "media.costs.noresults.title": "No costs to display",
    "media.fees.noresults.title": "No fees to display",
    "media.fields.noresults.subtitle":
      "Start now creating the first one by clicking",
    "market-finance.financial.tax.title": "No tax to display",
    "market-finance.financial.tax.subtitle":
      "Start now creating the first one by clicking",
    "market-finance.financial.tax.add_new": "New Tax",
    "cannot.disable.tax": "Tax cannot be unavailable",
    "cannot.deactivate.tax": "Tax cannot be deactivated",
    "media.fields.add_new_subtitle": "New Fee",
    "media.fields.costs.noresults.title": "No costs to display",
    "media.fields.commissions.noresults.title": "No commissions to display",
    "media.fields.commissions.add_button": "New Commission",
    "media.fields.commissions.noresults.subtitle":
      "Start now creating the first one by clicking",
    "market-agencies.tabs.commissions": "Commissions",
    PERCENTAGE: "Percentage",
    FIXED_AMOUNT: "Fixed Amount",
    AC: "Agency Commission",
    MC: "Media Commission",
    GROSS: "Gross",
    NET: "Net",
    PRODUCTION: "Passthrough Costs",
    "commission.computedOn.GROSS": "Gross",
    "commission.computedOn.NET": "Net",
    "commission.computedOn.PRODUCTION": "Passthrough Costs",
    "commission.amount.FIXED_AMOUNT": "Fixed Amount",
    "commission.amount.PERCENTAGE": "Percentage",
    "commission.semantic.AC": "Agency Commission",
    "commission.semantic.MC": "Media Commission",
    "commissions.mediaTypeSemantics.add": "add Media Types",
    "commissions.mediaSubtypeSemantics.add": "add Submedia Types",
    "commissions.vendorProductIds.add": "add Vendor Products",
    "commissions.mediaTypeSemantics.more": "more",
    "commissions.mediaSubtypeSemantics.more": "more",
    "commissions.vendorProductIds.more": "more",
    "commissions.list.delete.action": "Delete",
    "admin.commissions.delete.title": "Delete Commission",
    "admin.commissions.delete.description":
      "Are you sure you want to delete this Commission?",
    "admin.commissions.delete.action": "Delete",
    "admin.commissions.add.placeholder": "Select Commission to add...",
    "admin.commissions.add.label": "Commission",
    "admin.commissions.add.label.placeholder": "Add Commission...",
    "admin.commissions.or": "or",
    "admin.commissions.create_button": "Create New",

    //
    "import.settings.client": "Import Settings from another Client",
    "import.settings.client_group": "Import Settings from Client Group",
    "import.settings.client_group.title": "Import from Client Group",
    "import.settings.client_group.description1":
      "You are about to import all settings regarding Media Types and Media Fields as set to ",
    "import.settings.client_group.description2":
      " . MBA configuration will be affected too. Any existing items will be replaced. This action can not be undone.",
    "import.settings.client_group.action": "Import Settings",
    "import.settings.client.title": "Import from Client",
    "import.settings.client.description":
      "You are about to import all settings regarding Media Types and Media Fields from another Client. MBA configuration will be affected too. Any existing items will be replaced. This action can not be undone.",
    "import.settings.client.action": "Import Settings",

    //
    "vendors.list.title": "Vendors",
    "vendors.list.empty": "No vendors to display",
    "vendors.actions.addNew": "new vendor",
    "vendors.activate.success": "vendor activated",
    "vendors.deactivate.success": "vendor deactivated",
    "vendors.deactivate.error": "error deactivating vendor",
    "vendors.deactivate.title": "Deactivate Vendor",
    "vendors.deactivate.description":
      "Are you sure you want to deactivate this vendor?",
    "vendors.vendorProduct.add.error": "error adding new vendor product",
    "vendors.vendorProduct.update.error": "error updating vendor product",

    "vendors.actions.associate": "+ Assign Vendor",
    "vendors.associate.title": "Assign Vendor",
    "vendors.associate.input": "Vendor",
    "vendors.associate.submit": "Assign",
    "vendors.associate.empty": "Select Vendor to assign",
    "vendors.associate.filled": "Vendors selected",
    "vendors.assign": "Select Vendors to assign",
    "mediaOwner.actions.associate": "+ Assign Media Owner",
    "mediaOwner.associate.title": "Assign Media Owner",
    "mediaOwner.associate.input": "Media Owner",
    "mediaOwner.associate.submit": "Assign",
    "mediaOwner.associate.empty": "Select Media Owner to assign",
    "mediaOwner.associate.filled": "Media Owners selected",
    "mediaOwner.assign": "Select Media Owners to assign",

    "vendors.actions.dissociate": "Remove",
    "vendors.dissociate.title": "Remove Vendor",
    "vendors.dissociate.description":
      "Are you sure you want to remove this vendor?",
    "vendors.dissociate.success": "Vendor removed",
    "vendors.dissociate.error": "Error removing vendor",
    "vendors.dissociate.submit": "Remove",
    "mediaOwner.actions.dissociate": "Remove",
    "mediaOwner.dissociate.title": "Remove Media Owner",
    "mediaOwner.dissociate.description":
      "Are you sure you want to remove this Media Owner?",
    "mediaOwner.dissociate.success": "Media Owner removed",
    "mediaOwner.dissociate.error": "Error removing Media Owner",
    "mediaOwner.dissociate.submit": "Remove",

    "vendors.create.title": "Create Vendor",

    "vendors.columns.name": "Vendor",
    "vendors.columns.status": "Status",
    "vendors.columns.vendorgroup": "Vendor Group",

    "vendors.tabs.connected_vendors": "Connected Vendors",
    "vendors.tabs.media_owners": "Media Owners",
    "cannot.change.mediaOwner": "The media owner cannot be changed",
    "vendors.profile.section.details": "Details",
    "vendors.profile.section.companies": "Associated companies",
    "vendors.profile.section.addresses": "Business Address",
    "vendors.fields.localName": "Local Name",
    "vendors.fields.code": "Code",
    "vendors.fields.groupName": "Vendor Group",
    "vendors.fields.marketName": "Market",
    "vendors.fields.subRegionName": "Sub-Region",
    "vendors.fields.regionName": "Region",
    "vendors.fields.address.address1": "Address 1",
    "vendors.fields.address.address2": "Address 2",
    "vendors.fields.address.countryCode": "Country",
    "vendors.fields.address.state": "State/Province",
    "vendors.fields.address.city": "City",
    "vendors.fields.address.zipCode": "Zip Code",
    "vendors.fields.vendorType": "Vendor Type",
    "vendors.fields.vendorType.PUBLIC": "Public",
    "vendors.fields.vendorType.INTERCOMPANY": "Intercompany",
    "vendors.fields.company": "Company",
    "vendors.fields.mediaOwner": "Media Owner",
    "vendors.fields.mediaOwner.MEDIA_OWNER": "Yes",
    "vendors.fields.mediaOwner.CONNECTED_VENDOR": "No",
    "vendor.fees.type.addList": "Add List",
    "vendor.fees.type.viewList": "View List",

    "fees.mediaTypeSemantics.add": "add Media Types",
    "fees.vendorProductIds.add": "add Vendor Products",
    "fees.mediaTypeSemantics.more": "more",
    "fees.vendorProductIds.more": "more",
    "fee.amount.FIXED_AMOUNT": "Fixed Amount",
    "fee.amount.PERCENTAGE": "Percentage",
    "fee.semantic.MANAGEMENT": "Management",
    "fee.semantic.BOOKING": "Booking",
    "fee.semantic.PRODUCTION": "Production",
    "fee.semantic.TALENT": "Talent",
    "fee.semantic.RETAINER": "Retainer",
    "fee.semantic.PLANNING": "Planning",
    "fee.semantic.OTHERS": "Others",
    "fee.computedOn.GROSS": "Gross",
    "fee.computedOn.NET": "Net",
    "fees.list.delete.action": "Delete",
    "admin.cost.delete.title": "Delete Cost",
    "admin.cost.delete.description":
      "Are you sure you want to delete this Cost?",
    "admin.cost.delete.action": "Delete",
    "admin.fees.add.placeholder": "Select Fee to add...",
    "admin.fees.add.label": "Fee",
    "admin.fees.add.label.placeholder": "Add Fee...",
    "admin.costs.add.placeholder": "Select Cost to add...",
    "admin.costs.add.label": "Cost",
    "admin.costs.add.label.placeholder": "Add Cost...",
    "admin.costs.or": "or",
    "admin.fees.create_button": "Create New",
    "admin.costs.create_button": "Create New",
    "admin.fee.create_button": "+ New Fee",
    "admin.cost.create_button": "+ New Cost",
    "media.costs.add_new_subtitle": "New Cost",
    "admin.commission.create_button": "+ New Commission",

    "tax.amount.FIXED_AMOUNT": "Fixed Amount",
    "tax.amount.PERCENTAGE": "Percentage",
    "tax.semantic.INTERSTATE": "Interstate",
    "tax.semantic.INTRASTATE": "Intrastate",
    "tax.semantic.NON_GST": "Non GST",
    "tax.semantic.VAT": "VAT",
    "tax.semantic.EXEMPTION": "Exemption",
    "tax.taxType.NORMAL": "Normal",
    "tax.taxType.WITHHOLDING": "Withholding",
    "tax.taxType.EXEMPTION": "Exemption",
    "tax.taxUsage.AC": "Agency Commission",
    "tax.taxUsage.MC": "Media Cost",
    "market.taxes.taxUsage.AC": "AC",
    "market.taxes.taxUsage.MC": "MC",
    "market.client.taxes": "Taxes",
    "client.taxes.ac.title": "AC Tax Usage",
    "client.taxes.MC.title": "MC Tax Usage",
    "client.tax.empty-state.title": "No client taxes to display",
    "client.taxes.list.set-default.action": "Set as default",
    "client.taxes.list.unavailable.action": "Make Unavailable",
    "client.taxes.list.enable.action": "Make Available",
    "client.taxes.list.label": "Label",
    "client.taxes.list.semantic": "Semantics",
    "client.taxes.list.taxType": "Tax Type",
    "client.taxes.list.erpCode": "ERP Code",
    "client.taxes.list.amount": "Amount",
    "client.taxes.list.taxUsage": "Tax Usage",
    "client.taxes.list.status": "Status",
    "agency.client.taxes.modal.set-default.title": "Set Tax as Default",
    "agency.client.taxes.modal.set-default.description":
      "Are you sure you want to set this tax as a default?",
    "modal.label.set-default": "Default",
    "agency.client.taxes.modal.disable.title": "Disable Tax",
    "agency.client.taxes.modal.disable.description":
      "Are you sure you want to disable this tax?",
    "modal.label.disable": "Disable",
    "agency.client.taxes.modal.enable.title": "Enable Tax",
    "agency.client.taxes.modal.available.description":
      "Are you sure you want to enable this tax?",
    "modal.label.enable": "Enable",
    "client.taxes.ac.noresults.title": "No Taxes to display yet",
    "client.taxes.mc.noresults.title": "No Taxes to display yet",

    "agency.supplier.taxes.modal.enable.title": "Enable Tax",
    "agency.supplier.taxes.modal.available.description":
      "Are you sure you want to enable this tax?",
    "agency.supplier.taxes.modal.disable.title": "Disable Tax",
    "agency.supplier.taxes.modal.disable.description":
      "Are you sure you want to enable this tax?",
    "agency.supplier.taxes.modal.set-default.title": "Set Tax as Default",
    "agency.supplier.taxes.modal.set-default.description":
      "Are you sure you want to set this tax as a default?",
    "supplier.taxes.mc.noresults.title": "No Taxes to display yet",
    "supplier.taxes.list.set-default.action": "Set as default",
    "supplier.taxes.list.disable.action": "Make Unavailable",
    "supplier.taxes.list.enable.action": "Make Available",

    "taxes.list.delete.action": "Delete",
    "admin.taxes.delete.title": "Delete Tax",
    "admin.taxes.delete.description":
      "Are you sure you want to delete this Tax?",
    "admin.taxes.delete.action": "Delete",
    "admin.taxes.add.placeholder": "Select Tax to add...",
    "admin.taxes.add.label": "Tax",
    "admin.taxes.add.label.placeholder": "Add Tax...",
    "admin.taxes.or": "or",
    "admin.taxes.create_button": "+ New Tax",

    "nav.market.settings": "Market Settings",
    "nav.market.companies": "Companies",
    "nav.market.clients": "Clients",
    "nav.market.agencies": "Agencies",
    "nav.market.vendors": "Vendors",
    "nav.market.taxes": "Financial",
    "nav.market.team": "Team",
    "nav.market.targets": "Targets",
    "company.tabs.targets": "Targets",
    "company.tabs.universe": "Universe",
    "market-finance.targets.title": "No targets to display",
    "admin.targets.create_button": "+ New Target",
    "admin.targets.activate.title": "Activate Target",
    "admin.targets.activate.description":
      "Are you sure you want to activate this target?",
    "admin.targets.deactivate.title": "Deactivate Target",
    "admin.targets.deactivate.description":
      "Are you sure you want to deactivate this target?",
    "admin.targets.delete.title": "Delete Target",
    "admin.targets.delete.description":
      "Are you sure you want to delete this Target?",
    "admin.targets.delete.action": "Delete",
    "admin.targets.mismatch.error": "Target and Universe mismatch",
    "admin.addNewVariable": "Add Variable",
    "admin.field.wrong.format.error": "Invalid range format",
    "admin.field.format.placeholder":
      "Please provide a valid age range ex.: 20-30",
    "market.addVariable.done": "Done",
    "market.addVariable.cancel": "Cancel",
    "market.target.create.title": "Create Target",
    "market.target.input.socioeconomics": "Socioeconomics",
    "market.target.input.age": "Age Range",
    "market.target.input.gender": "Gender",
    "market.target.input.type": "Type of Work",
    "market.target.button.cancel": "Cancel",
    "market.target.button.create": "Create",
    "market.universe.create.title": "Add Year",
    "market.universe.create.subtitle":
      "Select the year you would like to add the Universe to:",
    "market.universe.input.type": "Select Year",
    "market.universe.delete.title": "Delete Year",
    "market.universe.delete.description":
      "Are you sure you want to delete this Year?",
    "market.universe.button.cancel": "Cancel",
    "market.universe.button.add": "Add",
    "market.universe.empty.add.title": "Add a Universe",
    "market.universe.empty.add.subtitle":
      "Select the year you would like to add the Universe for.",
    "market.universe.modal.delete.title": "Delete Universe",
    "market.universe.modal.delete.description":
      "Are you sure you want to delete this Universe?",
    "market.universes.empty.table": "No Universes added yet",
    "market.universes.empty.table.filtered": "No Universes to display",
    "market.universes.empty.add.universe": "Add Universe",
    "market.universe.add.record": "+ New Record",
    "market.universes.add.new.ageRange": "Age Range...",
    "market.universes.add.new.socioeconomics": "Socioeconomics...",
    "market.universes.add.new.gender": "Gender...",
    "market.universes.add.new.typeOfWork": "Type of Work...",
    "market.universes.add.new.population": "Population...",
    "market.universes.add.new.variables.AGE_RANGE": "Age Range...",
    "market.universes.add.new.variables.SOCIOECONOMICS": "Socioeconomics...",
    "market.universes.add.new.variables.GENDER": "Gender...",
    "market.universes.add.new.variables.TYPE_OF_WORK": "Type of Work...",
    "market.universes.filters.title": "Filter Universe",
    "market.fetch.rankings.toggle": "Fetch Ranking feature",
    "market.fetch.rankings.on": "On",
    "market.enable.oxygen.toggle": "Enable Oxygen",
    "market.enable.oxygen.on": "On",
    "market.enable.preeval.toggle": "Enable Pre-Evaluation feature",
    "market.enable.preeval.on": "On",
    "market.enable.digitalExport.toggle": "Enable Digital Export feature",
    "market.enable.digitalExport.on": "On",
    "market.enable.postToIsap.on": "On",
    "market.enable.postToIsap.toggle": "Enable Post to ISAP feature",

    "market.enable.posteval.toggle": "Enable Post-Evaluation Feature",
    "market.enable.posteval.on": "On",
    "market.enable.crud.products.toggle":
      "Enable Create, Edit, Delete Products",
    "market.enable.crud.products.on": "On",

    "filters.gender": "Gender",
    "filters.ageRange": "Age Range",
    "filters.socioeconomics": "Socioeconomics",
    "filters.typeOfWork": "Type of Work",

    AGE_RANGE: "Age Range",
    SOCIOECONOMICS: "Socioeconomics",
    GENDER: "Gender",
    TYPE_OF_WORK: "Type of Work",
    population: "Population",
    "nav.teams": "Teams",
    "agency.client.teams.noresults.title": "No team to display",
    "agency.client.teams.noresults.subtitle":
      "Start now assigning to a team by clicking",
    "teams.member.list.delete.title": "Delete Member",
    "teams.member.list.delete.description":
      "Are you sure you want to delete this Member?",
    "teams.member.list.delete.action": "Delete",
    "teams.create.button": "+ New Team",
    "member.create.button": "+ New Member",
    "teams.create.title": "Create Team",
    "teams.input.name": "Name",
    "teams.noresults.title": "No team to display",
    "teams.noresults.subtitle": "Start now creating a new one by clicking",
    "teams.create_new": "New Member",
    "teams.delete.error": "Error deleting Team",
    "agency.teams.add_new": "New Member",
    "teams.button.cancel": "Cancel",
    "teams.button.submit": "Submit",
    "teams.list.name": "Name",
    "teams.list.mail": "Email",
    "teams.list.role": "Role",
    "teams.list.market": "Market",
    "teams.list.subRegion": "Sub-Region",
    "teams.list.agencies": "Agencies",
    "teams.list.companies": "Companies",
    "teams.list.actions": "Actions",
    "teams.more.subRegion": "more",
    "teams.member.create.title": "Add Member",
    "teams.member.edit.title": "Edit Member",
    "teams.member.input.name": "Name",
    "teams.member.input.role": "Role",
    "teams.member.input.agency": "Agency",
    "teams.member.button.cancel": "Cancel",
    "teams.member.button.add": "Add",
    "teams.member.button.save": "Save",
    "role.list.GLOBAL_FINANCE": "Global Finance",
    "role.list.REGIONAL_FINANCE": "Regional Finance",
    "role.list.MARKET_ADMINISTRATOR": "Market Administrator",
    "role.list.MARKET_FINANCE": "Market Finance",
    "role.list.AGENCY_ADMINISTRATOR": "Agency Administrator",
    "role.list.AGENCY_FINANCE": "Agency Finance",
    "role.list.PLANNER": "Planner",
    "role.list.BILLER": "Biller",
    "role.list.BUYER": "Buyer",
    "role.list.MANAGING_DIRECTOR": "Managing Director",

    "agency.client.profile": "Profile",
    "agency.client.products": "Products",
    "agency.client.teams": "Teams",
    "agency.client.flow": "Flow",
    "agency.client.media-types": "Media Types",
    "agency.client.fields": "Fields",
    "agency.client.targets": "Targets",
    "agency.client.taxes": "Taxes",
    "agency.client.copies": "Copies",
    "agency.client.copies.title": "Copies",
    "agency.client.copies.name": "Name",
    "agency.client.copies.status": "Status",
    "agency.client.copies.creativeAgencyName": "Creative Agency",
    "agency.client.copies.copyQualityName": "Copy Quality",
    "agency.client.copies.duration": "Duration",
    "agency.client.copies.externalCode": "External Code",
    "agency.client.copies.dateCreated": "Date Created",
    "agency.client.copies.productName": "Product Name",
    "agency.client.copies.clientName": "Client Name",
    "agency.client.copies.mediaSemanticName": "Media Semantic Name",
    "agency.client.copies.integrationStatus": "Integration Status",
    "agency.client.copies.error": "Integration details",
    "agency.client.copies.actions": "Actions",
    "copies.action.updateCode": "Update External code",
    "copies.action.delete": "Delete",
    "agency.client.copies.empty.table": "No Copies available",
    "agency.client.copies.modal.delete.title": "Delete Copy",
    "agency.client.copies.modal.delete.description":
      "Are you sure you want to delete the Copy?",
    "agency.client.copies.modal.activate.title": "Activate Copy",
    "agency.client.copies.modal.activate.description":
      "Are you sure you want to activate the Copy?",
    "agency.client.copies.modal.deactivate.title": "Deactivate Copy",
    "agency.client.copies.modal.deactivate.description":
      "Are you sure you want to deactivate the Copy?",
    "agency.client.commissions": "Commissions",
    "agency.client.costs": "Fees",
    "agency.client.exchange_rates": "Exchange Rates",
    "agency.client.templates": "Templates",
    "agency.client.documents": "Documents",
    "agency.client.external-ids": "External IDs",
    "agency.client.taxonomy.externalIdLabel": "External ID Label",
    "agency.client.taxonomy.externalIdPattern": "External ID Pattern",
    "agency.client.taxonomy.external-id-pattern.edit": "Edit",
    "agency.client.taxonomy.BOOKING_ORDER": "Booking Order",
    "agency.client.taxonomy.LINE_ITEM": "Line Item",
    "agency.client.taxonomy.out_of_home": "Out of Home",
    "agency.client.taxonomy.print": "Print",
    "agency.client.taxonomy.digital": "Digital",
    "agency.client.taxonomy.radio": "Radio",
    "agency.client.taxonomy.tv": "TV",
    "agency.client.taxonomy.other": "Other",
    "agency.client.taxonomy.event": "Event",
    "agency.client.taxonomy.cinema": "Cinema",
    "agency.client.taxonomy.mobile": "Mobile",
    "agency.client.taxonomy.external-id.no-result":
      "There aren't any available taxonomies",
    "taxonomy.external-id-pattern.modal.add-field": "+ Add Field",
    "taxonomy.external-id-pattern.modal.clear-all": "Clear All",
    "taxonomy.external-id-pattern.modal.create-btn": "Add",
    "taxonomy.add-media-type-modal.title": "Add Media Type",
    "taxonomy.external-id-pattern.modal.unique-no": "Unique No",
    "taxonomy.external-id-pattern.modal.no-options": "No options",
    "taxonomy.add-media-type-modal.subtitle":
      "Select the Media Type that you want to add:",
    "taxonomy.add-media-type-modal.input.type": "Select Media Type",
    "taxonomy.add-media-type-modal.button.cancel": "Cancel",
    "taxonomy.add-media-type-modal.button.add": "Add",
    "external-id.dialog.apply": "Apply",
    "external-id.dialog.cancel": "Cancel",
    "agency.client.external-id.pattern.edit.title":
      "External ID Number Pattern",
    "agency.client.external-id.pattern.edit.subtitle":
      "Please create below the pattern based on which all the Booking Orders’ External IDs are going to be created. Start by selecting the fields that will form the pattern.",
    "agency.client.taxonomy.status": "Status",
    "taxonomy.names": "Taxonomy Names",
    "taxonomy.across-media-types.title": "Across all Media Types",
    "taxonomy.per-media-type.title": "Specific per Media Type",
    "taxonomy.per-media-type.noresults.title": "No External IDs to display yet",
    "taxonomy.per-media-type.noresults.subtitle":
      "Start by adding a Media Type",
    "taxonomy.per-media-type.noresults.add_button": "Add a New Media Type",
    "taxonomy.per-media-type.delete.title": "Remove tab",
    "taxonomy.per-media-type.delete.description":
      "Deleting this tab will result in the deletion of all associated External IDs. Are you sure you want to remove this tab?",
    "taxonomy.add.dynamic.content": "+ Add Field",
    "agency.client.taxonomy.entityType": "External ID Label",
    "agency.client.taxonomy.content": "External ID Pattern",
    "agency.client.external-id.pattern.information":
      "Deleting all fields from the pattern will trigger an automatic update in the status column.",
    "agency.client.details": "Agency Details",
    "agency.client.localName": "Local Name",
    "agency.client.code": "Code",
    "agency.client.market": "Market",
    "agency.client.ipg.name": "IPG Company",
    "agency.client.company.name": "ISAP Company",
    "agency.client.company.code": "Code",
    "agency.client.taxRegistrationNumber": "Tax. Reg. No.",
    "agency.client.profit": "Profit Center",
    "agency.client.cost": "Cost Center",
    "agency.client.region": "Region",
    "agency.client.subregion": "Sub-Region",
    "agency.client.addresses": "Addresses",
    "agency.client.client-groups": "Client Group",
    "agency.client.budgetPlanning": "Plan Budget on",
    "agency.client.budgetPlanning.GROSS_COST": "Total Gross",
    "agency.client.budgetPlanning.NET_COST": "Total Net",
    "agency.client.budgetPlanning.BILLABLE": "Net Payable",
    "agency.client.approved.title": "Client Approvers:",
    "agency.client.approved.option.threshold_levels": "Threshold Levels",
    "agency.client.approved.option.manual": "Manual",
    "client.thresholdLevels.selected.text":
      "By selecting this option, the approvers of the Campaign / Media Plan are based on the threshold level defined below",
    "client.manual.selected.text":
      "Set the approvers of the Campaign / Media Plan that can be selected manually from Campaign Owner / Team Lead ",
    "agency.client.approval.manual.levels.add.row": "Add Approver",
    "agency.client.team.lead.title": "Planning Team Leads",
    "agency.client.team.lead.teams.first_text": "Manage Team Leads under",
    "agency.client.team.lead.teams.button": "Teams",
    "agency.client.team.lead.teams.second_text": "tab",
    "agency.client.targets.title": "Targets for Media Type TV",
    "agency.client.targets.name": "Target",
    "agency.client.targets.universe": "Universe",
    "agency.client.targets.externalCode": "External Code",
    "agency.client.targets.enabled": "Actions",
    "agency.client.targets.noresults.title": "No targets to display",
    MONDAY: "Monday",
    TUESDAY: "Tuesday",
    WEDNESDAY: "Wednesday",
    THURSDAY: "Thursday",
    FRIDAY: "Friday",
    SATURDAY: "Saturday",
    SUNDAY: "Sunday",
    "agency.businessAddress": "Business Address",
    "agency.billingAddress": "Billing Address",
    "agency.billing.contact": "Billing Contact",
    "agency.contact.address": "Contact Address",
    "agency.contact.info": "Contact Info",
    "agency.terms.desc":
      "Terms and Conditions will be included in official documents i.e MBA",

    "contact.title": "Title",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.phone.type": "Type",
    "contact.phone.number": "Number",
    "contact.phone.extension": "Extension",

    "phone.type.business": "Business Phone",
    "phone.type.mobile": "Mobile Phone",
    "phone.type.office": "Office Phone",
    "phone.type.home": "Home Phone",
    "add.phone": "Add Phone",

    "address.address1": "Address 1",
    "address.address2": "Address 2",
    "address.country": "Country",
    "address.state": "State / Province",
    "address.city": "City",
    "address.zipCode": "Zip Code",
    "copy.business.address": "Copy Business Address",
    "copy.billing.address": "Copy Billing Address",

    "agency.client.approval": "Campaigns / Media Plans need to be",
    "agency.client.requires.approval": "Approved",
    "agency.client.approval.option.internal": "Internal",
    "agency.client.approval.option.client": "Client",
    "agency.client.authorized": "Authorized",
    "agency.client.campaign.bank.can.be": "Campaign Bank can be",
    "agency.client.bank.enabled": "Enabled",
    "agency.client.booking.orders.can.be": "Booking Orders need to be",
    "agency.client.booking.orders.approved": "Approved",
    "agency.client.approval.levels.empty": "Approver levels are not yet set up",
    "agency.client.approval.levels.add.row": "Add Another Level",
    "agency.client.approval.levels.first.row": "Add Level",
    "agency.client.costs.transparency": "Costs Transparency",
    "agency.client.costs.transparency.enabled": "Enabled",
    "agency.client.costs.transparency.text":
      "By enabling this option, Booking costs will be known to the Planner and a change in the BO costs will be reflected in the Media Plan ",
    "agency.client.levels.name": "Name",
    "agency.client.levels.amountThreshold": "Amount",
    "agency.client.levels.approverFirstName": "Approver's First Name",
    "agency.client.levels.approverLastName": "Approver's Last Name",
    "agency.client.levels.approverEmail": "Approver's email",

    "agency.client.product.name": "Product name",
    "agency.client.product.division": "Division",
    "agency.client.product.code": "Code",
    "agency.client.product.startWeekDay": "Start Week Day",

    "agency.client.general.info": "General Info",
    "agency.client.fiscal.year": "Fiscal Year",
    "agency.client.week.day": "Start Week Day",
    "agency.client.division": "Division",
    "agency.client.products.noresults.title": "No products to display",
    "agency.client.payment.terms.conditions": "Payment Terms & Conditions",
    "agency.payment.info":
      "Terms and Conditions will be included in the invoice print outs",
    "products.create.button": "+ Create Product",
    "products.create.title": "Create Product",
    "products.edit.title": "Edit Product",
    "products.input.name": "Product Name",
    "products.input.code": "Product Code",
    "products.input.clientId": "ClientId",
    "products.input.division": "Division",
    "products.input.start-week-day": "Start of Week",
    "products.input.start-week-day.SUNDAY": " Sunday",
    "products.input.start-week-day.MONDAY": "Monday",
    "products.input.start-week-day.TUESDAY": "Tuesday",
    "products.input.start-week-day.WEDNESDAY": "Wednesday",
    "products.input.start-week-day.THURSDAY": "Thursday",
    "products.input.start-week-day.FRIDAY": "Friday",
    "products.input.start-week-day.SATURDAY": "Saturday",
    "products.button.cancel": "Cancel",
    "products.button.submit": "Submit",
    "products.button.edit": "Edit",
    "product.actions": "Actions",
    "product.edit.action": "Edit",
    "product.delete.action": "Delete",
    "agency-products.list.delete.title": "Delete Product",
    "agency-products.list.delete.description":
      "Are you sure you want to delete this Product?",
    "agency-products.list.delete.action": "Delete",
    "agency-products.list.delete.error": "Cannot delete product",

    "agency.client.teams.empty.title": "No Client Teams to display",
    "agency.client.team.name": "Team",
    "agency.client.team.users": "Number of Members",

    "nav.agency.clients": "Clients",
    "nav.agency.companies": "Companies",
    "nav.agency.mediatypes": "Media types",
    "nav.agency.vendors": "Vendors",
    "nav.agency.teams": "Teams",
    "nav.agency.documents": "Documents",

    "agency.client.internal.approver": "Approver",
    "agency.client.teams.assign": "+ Assign Teams",
    "agency.client.teams.select": "Select Teams to assign",
    "agency.client.teams.add.team.lead": "Add Team Lead",
    "agency.teams.empty.title": "No Team Members to display",
    "agency.teams.empty.subtitle":
      "We couldn’t find any Members matching your criteria.",
    "agency.client.team.assign": "Assign Teams",

    "agency.client.delete.action": "Delete",
    "agency.client.activate.action": "Activate",
    "agency.client.deactivate.action": "Deactivate",

    "plan.upload.again": "Upload another file",
    "plan.upload.anyway": "Import anyway",

    "nav.market.mediatypes": "Media Types",
    "nav.market.mediafields": "Fields",

    "levels.validation.errors":
      "The approver levels could not be saved! Please make sure you have defined at least one level and all fields are filled.",

    "dashboards.filters.kinds_of_amount.net": "Net",
    "dashboards.filters.kinds_of_amount.gross": "Gross",
    "dashboards.filters.kinds_of_amount.total": "Total",
    "dashboards.filters.kinds_of_amount.mediaCost": "Media Cost",
    "dashboards.filters.kinds_of_amount.netPayable": "Net Payable",
    "dashboards.filters.kinds_of_amount.ac": "AC",

    "agency.client.flow.success": "The approval flow was saved!",
    "agency.client.levels.level": "Level",
    "agency.client.levels.threshold": "Threshold",
    "agency.client.levels.FirstName": "First Name",
    "agency.client.levels.Email": "Email Address",
    "agency.client.levels.title": "Title",

    spots: "Spots",
    "spots.enabled": "Enabled",
    "spots.disabled": "Disabled",

    out_of_home: "Out of home",

    "customize.ganttchart.indicators": "Gantt Chart indicators",

    "plan.create.overview.product": "Product",
    "plan.button.undo": "Undo",

    "rate.cards.name": "Name",
    "rate.cards.vendorProducts": "Vendor Product",
    "rate.cards.vendorProducts.more": "more",
    "rate.cards.channels.more": "More",
    "rate.cards.media.owner": "Media Owner",
    "rate.cards.media.type": "Media Type",
    "rate.cards.effective.date": "Effective Date",
    "rate.cards.status": "Status",
    "rate.cards.actions": "Actions",
    "rate.card.activate.action": "Activate",
    "rate.card.deactivate.action": "Deactivate",
    "rate.card.delete.action": "Delete",
    "rate.card.modal.activate.title": "Activate Rate Card",
    "rate.card.modal.deactivate.title": "Deactivate Rate Card",
    "rate.card.modal.delete.title": "Delete Rate Card",
    "rate.card.modal.delete.description":
      "Are you sure you want to delete the Rate Card?",
    "rate.card.modal.activate.description":
      "Are you sure you want to activate the Rate Card?",
    "rate.card.modal.deactivate.description":
      "Are you sure you want to deactivate the Rate Card?",
    "rate.card.activate.success": "Rate Card successfully activated",
    "rate.card.deactivate.success": "Rate Card successfully deactivated",
    "rate.card.delete.success": "Rate Card successfully deleted",
    "rate.card.activate.error": "Error activating Rate Card",
    "rate.card.deactivate.error": "Error deactivating Rate Card",
    "rate.card.delete.error": "Error deleting Rate Card",
    "new.card.rate": "New Rate Card",

    "rate.card.name": "Name",
    "rate.card.create": "Create Rate Card",
    "rate.cards.list.empty": "No Rate Cards to display",
    "rate.cards.list.empty.subtitle":
      "Start now creating the first one by clicking",
    "rate.cards.list.add_button": "New Rate Card",
    "rate.card.loading.description": "Description",
    "rate.card.loading.percentage": "Percentage (%)",
    "rate.card.loading.dateRange": "Date Range",
    "rate.card.loading.actions": "Actions",
    "rate.card.loading.actions.delete": "Delete",
    "rate.card.loading.create": "+ New Loading",
    "rate.card.loading.description.placeholder": "Add Description...",
    "rate.card.loading.percentage.placeholder": "Add %...",
    "rate.card.loading.dateRange.placeholder": "Select Date...",
    "rate.card.loading.list.delete.title": "Delete Loading",
    "rate.card.loading.list.delete.description":
      "Are you sure you want to delete this Loading?",
    "rate.card.loading.list.delete.action": "Delete",
    "description.placeholder": "Add Description",
    "percentage.placeholder": "Add Percentage",
    "dateRange.placeholder": "Select Date Range",
    "rate-card.create_button": "+ New Row",
    "rate-card.filters.title": "Filter Rate Card",
    "rate.card.initial.channels.title": "Add Vendor Product",
    "rate.card.initial.channels.subtitle":
      "Descriptive text for adding vendor product ",
    "rate.card.initial.channels.label": "Vendor Product (optional)",
    "rate.card.dimensions.title": "Add New Base Rate",
    "rate.card.dimensions.subtitle": "Choose your Base Rate table columns",
    "rate.card.dimensions.targetB": "Target",
    "empty.base.rate": "This Base Rate is empty",
    "rate.card.vendorProduct.add.title": "Add Vendor Product",
    "rate.card.location.add.title": "Add Location",
    "rate.card.location.title.used": "The location title has already been used",
    "base.rate.config.invalid": "Invalid Base Rate configuration",
    "admin.channel.delete.action": "Delete",
    "admin.channel.delete.title": "Delete Channel",
    "admin.channel.delete.description":
      "Are you sure you want to delete the Channel?",
    "admin.location.delete.action": "Delete",
    "admin.location.delete.title": "Delete Location",
    "admin.location.delete.description":
      "Are you sure you want to delete the Location?",

    "rate.card.dimensions.duration": "Edit Duration",
    "rate.card.dimensions.duration.new": "+ New Duration",

    "rate.card.dimensions.add.target.placeholder": "Target",

    "daysOfWeek.more": "more",
    "targetB.more": "more",
    "segment.more": "more",
    "category.more": "more",
    "timebelt.filter": "Timebelt",

    "rate.card.selection.title": "Rate Card",
    "no.base.rate.found": "No base rate found",
    "plans.list.setlatest.title": "set this version as the latest",
    "plans.list.setlatest.description":
      "Are you sure you want to set this version as the latest?",
    "plans.list.setlatest.action": "Set",
    "rateCard.channel.default.name": "Default",
    "no.changes.to.be.saved": "There are no changes to save",

    "clients.list.agency-name": "Agency name",
    "market.client.profile": "Profile",
    "market.client.products": "Products",
    "market.client.documents": "Documents",
    "market.tabs.profile": "Profile",
    "market.tabs.companies": "Companies",
    "market.tabs.clients": "Clients",
    "market.tabs.vendors": "Vendors",
    "market.tabs.team": "Team",
    "market.tabs.media-types": "Media Types",
    "market.tabs.fees": "Fees",
    "market.tabs.commissions": "Commissions",
    "market.tabs.documents": "Documents",

    "agency.client.team.lead": "Select Team Lead",
    "agency.client.team.leads": "Team Leads",
    "agency.client.team.leader": "Team Leader",
    "agency.client.team.leader.planning": "Planning",
    "agency.client.team.leader.buying": "Buying",
    "team.lead.empty": "No Team Leads have been set up.",
    "team.lead.empty.manage":
      "No Team Leads have been set up yet. Add Team Leads under “Teams” Tab",
    "team.lead.empty.subtitlle": "Start adding Team Leads",
    "planning.team.leads": "Planning Team Leads",
    "buying.team.leads": "Buying Team Leads",
    "manage.team.leads": "Manage Team Leads under “Teams” tab",

    "plans.list.validate.action": "Validate",
    "plans.list.save.and.validate.action": "Save and Validate",

    "config.documents.delete.prompt": "Delete file?",
    "config.documents.delete.cancel": "cancel",
    "config.documents.delete.confirm": "confirm",
    "config.documents.description": "documents",

    "fee.semantic.PASSTHROUGH_COSTS": "Passthrough costs",

    "days.SU": "Sunday",
    "days.MO": "Monday",
    "days.TU": "Tuesday",
    "days.WE": "Wednesday",
    "days.TH": "Thursday",
    "days.FR": "Friday",
    "days.SA": "Saturday",

    daysOfWeek: "Days of week",
    duration: "Duration",
    category: "Category",
    segment: "Segment",
    description: "description",
    timebelt: "Timebelt",
    addMore: "Add More",
    targetB: "Target",

    "exportType.atb": "mba",
    "exportType.digital": "mba-digital",
    "exportType.schedule": "schedule",

    "hour.picker.start": "from",
    "hour.picker.end": "to",

    "nav.bookingOrders": "Booking Orders",
    "bo.create_button": "+ New Booking Order",
    "bo.list.bookingOrder": "Booking Order",
    "bo.list.status": "Status",
    "bo.list.number": "Number",
    "bo.list.clientName": "Client",
    "bo.list.vendor": "Vendor",
    "bo.list.mediaOwner": "Media Owner",
    "bo.list.vendorProducts": "Vendor Products",
    "bo.list.mediaTypes": "Media Types",
    "bo.list.mediaTypes.more": "more",
    "bo.list.startDate": "Start Date",
    "bo.list.endDate": "End Date",
    "bo.list.mediaPlan": "Media Plan",
    "bo.list.createdDate": "Created Date",
    "bo.list.createdBy": "Created By",
    "bo.list.updatedDate": "Updated Date",
    "bo.list.actions": "Actions",
    "bo.list.vendors.more": "more",
    "bo.list.channels.more": "more",
    "bo.list.vendorProducts.more": "more",
    "bo.list.cancel.action": "Cancel",
    "bo.list.delete.action": "Delete",
    "bo.list.rutNumber": "Vendor Tax Reg No",
    "bo.delete": "Delete",
    "bo.delete.success": "Booking Order deleted successfully",
    "bo.delete.error": "Error deleting Booking Order",
    "error.cannot.cancel.booking.order.with.match.evaluated.spots":
      "Cannot cancel booking order with match evaluated spots",
    "error.cannot.delete.booking.order.with.posted.items":
      "Cannot delete booking order with posted items",
    "status.CANCELLED": "Canceled",
    "bo.modal.delete.title": "Delete Booking Order",
    "bo.modal.delete.description":
      "Are you sure you want to delete this Booking Order?",
    "create.bo.modal.title": "Create Booking Order",
    "create.bo.modal.instructions":
      "Select the criteria and preferences to issue the booking order",
    "create.bo.modal.vendors": "Vendor",
    "create.bo.modal.channels": "Vendor Product",
    "create.bo.modal.media-types": "Media Type",
    "create.bo.modal.locations": "Location",
    "create.bo.modal.durations": "Duration",
    "create.bo.modal.packages": "Package",

    "create.bo.modal.new": "Add New Criteria",
    "create.bo.modal.client": "Client",
    "create.bo.modal.campaign": "Campaign",
    "create.bo.modal.mediaPlan": "Media Plan",
    "create.bo.modal.criteria": "Criteria",
    "create.bo.modal.selection": "Selection",
    "create.bo.modal.vendor.instructions":
      "Vendor A is an Intercompany Vendor. A separate BO will be created",
    "create.bo.modal.add.criteria": "Add Criteria",
    "create.bo.modal.dates": "Line Item Start - End Date",
    "create.bo.modal.startDate": "Start Date",
    "create.bo.modal.endDate": "End Date",
    "create.bo.modal.split.preferences": "Split Preferences",
    "create.bo.modal.split.bo": "Split BO",
    "create.bo.modal.split.selected": "selected",
    "create.bo.modal.filter.VENDOR": "Per Vendor",
    "create.bo.modal.filter.MEDIA_TYPE": "Per Media Type",
    "create.bo.modal.filter.CHANNEL": "Per Vendor Product",
    "create.bo.modal.filter.DURATION": "Per Duration",
    "create.bo.modal.filter.LOCATION": "Per Location",
    "create.bo.modal.filter.PACKAGE": "Per Package",
    "create.bo.modal.filter.MONTH": "Per Month",
    "create.bo.modal.filter.BILLING_SUB_TYPE": "Per Sub-Billing Type",

    "create.bo.modal.filter.title": "Filter",
    "create.bo.modal.filter.by": "Filter By:",
    "create.bo.modal.bo.ordering.period": "BO Ordering Period",

    "create.bo.modal.create": "Create",
    "create.bo.modal.all.vendors": "All Vendors",
    "create.bo.modal.all.channels": "All Vendor Products",
    "create.bo.modal.all.media-types": "All Media Types",
    "create.bo.modal.all.locations": "All Locations",
    "create.bo.modal.all.durations": "All Durations",
    "create.bo.modal.all.packages": "All Packages",

    "vendors.bo.more": "More",
    "channels.bo.more": "More",
    "media-types.bo.more": "More",
    "locations.bo.more": "More",
    "durations.bo.more": "More",
    "packages.bo.more": "More",

    "vendors.bo.info.singular": "is an Intercompany Vendor.",
    "vendors.bo.info.plural": "are Intercompany Vendors.",
    "vendors.bo.info": "Separate BO(s) will be created",
    "bo.overview.details": "Details",
    "bo.overview.financial": "Financial Summary",
    "bo.overview.planDetails": "Media Plan Details",
    "bo.overview.planDetails.view.more": "View More",
    "bo.overview.planDetails.name": "Name",
    "bo.overview.planDetails.number": "Number",
    "bo.overview.planDetails.budget": "Budget",
    "bo.overview.planDetails.status": "Status",
    "bo.overview.planDetails.period": "Period",
    "bo.overview.planDetails.client": "Client",
    "bo.overview.planDetails.product": "Product",
    "bo.overview.createdBy": "Created By",
    "bo.overview.contactPerson": "Contact Person",
    "bo.overview.contractNumber": "Contract Number",
    "bo.overview.remarks": "Remarks",
    "bo.overview.activity": "Activity",
    "bo.overview.vendor": "Vendor",
    "bo.overview.mediaOwner": "Media Owner",
    "bo.overview.vendorProducts": "Vendor Products",
    "bo.overview.mediaType": "Media Type",
    "bo.overview.spotsType": "Spots Type",
    "bo.details.number": "Number",
    "bo.details.externalIdNumber": "External ID Number",
    "bo.details.version": "Version",

    "bo.details.vendor_ref_no": "Purchase Request Number",
    "bo.details.client_ref_no": "Sales Request Number",

    "bo.create.revision": "Revision",
    "bo.revision.title.on.update": "There have been made revisions in ",
    "bo.revision.title.on.submit": "There are some changes to be reviewed",
    "bo.discard.revision": "Discard Revision",
    "bo.modal.discard.revision": "Discard Revision",
    "bo.modal.discard.revision.description":
      "Changes have been made. Please confirm you’d like to discard all changes up to now.",
    "bo.save.revision": "Save Revision",
    "bo.modal.send.revision.title": "Send Revision Request",
    "submit.revision": "Submit Revision",
    "bo.modal.submit.revision.description":
      "Are you sure you want to submit revision?",
    "bo.modal.approve.revision": "Approve Revision",
    "bo.modal.approve.revision.description":
      "Are you sure you want to approve this revision?",
    "reject.revision": "Reject Revision",
    "add.bo-comment": "Add comment",
    "bo.revision.submit.error": "Error submitting revision",

    "plan.button.add.to.booking": "Add to Booking Order",
    "add.to.booking.order.title": "Add selected lines to a Booking Order",
    "add.to.booking.order.select": "Select a booking order",
    "add.to.booking.order.error":
      "Something went wrong in adding Line Items to a Booking Order",
    "add.to.booking.order.success":
      "Line Items added successfully to a Booking Order",

    "plan.button.remove.from.booking": "Remove from Booking Order",
    "remove.from.booking.confirmation.title":
      "Confirm removal from Booking Order",
    "remove.from.booking.confirmation.description":
      "You are about to remove the selected items from the Booking Order. Are you sure?",

    "plan.add.new.line.items.title":
      "New Line Items have been added to Media Plan",
    "plan.button.new.line.items.add": "Add new items to BO",
    "plan.button.new.line.items.discard": "Ok, got it",

    "activity.CREATE_BOOKING_ORDER": "Booking Order Creation",
    "activity.DELETE_BOOKING_ORDER": "Booking Order Deletion",
    "activity.ADD_ITEM_TO_BOOKING_ORDER": "Booking Order Item Addition",
    "activity.REMOVE_ITEM_FROM_BOOKING_ORDER": "Booking Order Item Removal",
    "activity.BOOKING_ORDER_REVISION_GENERAL": "Booking Order Revision",
    "activity.BOOKING_ORDER_ADD_ITEMS": "Booking Order Items Addition",
    "activity.BOOKING_ORDER_CREATE": "Booking Order Creation",
    "activity.BOOKING_ORDER_CANCELLED": "Booking Order has been Canceled",
    "activity.BOOKING_ORDER_DELETED": "Booking Order Deletion",
    "activity.BOOKING_ORDER_DISCARD_REVISION": "Booking Order Revision Discard",
    "activity.BOOKING_ORDER_ITEMS_POSTED": "Booking Order Items Posted",
    "activity.BOOKING_ORDER_ITEMS_REVISED": "Booking Order Items Revised",
    "activity.BOOKING_ORDER_POSTED": "Booking Order Posted",
    "activity.BOOKING_ORDER_REMOVE_ITEMS": "Booking Order Items Removal",
    "activity.BOOKING_ORDER_REVISION_APPROVAL_REQUEST":
      "Booking Order Revision Approval Request",
    "activity.BOOKING_ORDER_REVISION_APPROVED":
      "Booking Order Revision Approval",
    "activity.BOOKING_ORDER_REVISION_CANCELLED":
      "Booking Order Revision Cancelation",
    "activity.BOOKING_ORDER_REVISION_FOR_APPROVER":
      "Booking Order Revision for Approver",
    "activity.BOOKING_ORDER_REVISION_REJECTED":
      "Booking Order Revision Rejection",
    "activity.BOOKING_ORDER_REVISION_SUCCESSFUL":
      "Booking Order Revision Success",
    "activity.BOOKING_ORDER_UNDER_REVISION": "Booking Order Under Revision",
    "bookings.noresults.title": "No booking orders to display",

    "filters.plan.lines.label": "Filter the table",
    "no.vendors": "No Vendors",
    "no.vendor.products": "No Vendor Products",

    "financial.summary.CURRENCY": "Currency",
    "financial.summary.TOTAL_GROSS_COST": "Total Gross Cost",
    "financial.summary.MEDIA_COMMISSION": "Media Commission",
    "financial.summary.TOTAL_NET_COST": "Total Net Cost",
    "financial.summary.AGENCY_COMMISSION": "Agency Commission",
    "financial.summary.FEES": "Fees",
    "financial.summary.TAXES": "Taxes",
    "financial.summary.PASSTHROUGH_COSTS": "Passthrough Costs",
    "financial.summary.FINAL_PAYABLE": "Final Payable",

    "plan.new.mediatypes.placeholder.spotsPlan.amount": "Amount",
    "plan.new.mediatypes.placeholder.spotsPlan.label": "Spots Plan",
    "plan.new.mediatypes.header.spotsPlan": "Spots Plan",
    "media.table.new.media.spotsPlan": "Spots Plan",
    "media.table.new.media.select.spotsPlan": "Spots Plan",
    "media.table.new.media.select.spotsPlan.amount": "Amount",
    "customize.ganttchart.spotsPlan.label": "Spots Plan",
    "customize.ganttchart.spotsPlan.options.placeholder": "Select Spots Plan",
    "media.plan.spotsPlan.form.title": "Add",
    "media.plan.spotsPlan.form.type": "Type",
    "media.plan.spotsPlan.form.max": "Max No of",
    "media.plan.spotsPlan.spots.header.date": "Date",
    "media.plan.spotsPlan.spots.header.quantity": "No of",
    "media.plan.spotsPlan.spots.add": "Add",
    "media.plan.spotsPlan.spots.addmore": "Add More",
    "media.plan.spotsPlan.repeat.title": "Repeat",
    "media.plan.spotsPlan.spots.deleteSelected": "Delete",
    "media.plan.spotsPlan.spots.empty": "There are no entries yet",
    "media.plan.spotsPlan.spots.deselectAll": "Deselect All",
    "create.bo.modal.filter.SPOTS_PLAN_TYPE": "Per Billing Type",
    "create.bo.modal.spotsPlanTypes": "Billing Type",
    "create.bo.modal.all.spotsPlanTypes": "All Billing Types",
    "spotsPlanTypes.bo.more": "More",

    "digital.calculator.title": "Digital Calculator",
    "digital.calculator.guide":
      "Use the calculator to compute easily the costs of your media plan. The calculator works either way, so it may be used to calculate either the cost, CPM or number of impressions. Lock the value  you wish not to be altered in the computation.",
    "digital.calculator.buyingModel": "Buying Model",
    "digital.calculator.unitCost": "Unit Cost",
    "digital.calculator.additional.check": "Additional Metric",
    "digital.calculator.benchmark.unit": "Additional Metric",
    "digital.calculator.benchmark.value": "Benchmark Ratio",

    "customize.ganttchart.columns": "Columns",
    budget: "Budget",
    metric: "Metric",
    additionalMetric: "Additional Metric",

    "digital.calculator.grossCost": "Client cost",
    "digital.calculator.unitPrice": "Unit cost",

    "table.plan.filter.title": "Filter Media Plan",
    "table.plan.BOCosts.toggle.button": "Show Booking Costs",

    "secondary.key.title.planningMediaFields": "Planned",
    "secondary.key.title.buyingMediaFields": "Booked",
    "table.plan.planningCosts.toggle.button": "Show Planning Costs",
    "bo.line.item.resolve": "Resolve",
    "bo.changes.to.be.review": "There are lines with changes to be reviewed",
    "bo.show.only.lines.with.changes": "Show only lines with changes",
    "media.plan.changes.to.be.review":
      "There are lines with changes to be reviewed",
    "media.plan.show.only.lines.with.changes": "Show only lines with changes",
    "media.plan.optimization.active":
      "No changes can be done to the Media plan because there is an ongoing Oxygen Spot Optimization. Do you want to apply the changes made on the Spot Optimization?",
    "media.plan.optimization.mandatory.title": "Mandatory Fields",
    "media.plan.optimization.mandatory.message":
      "Please make sure all the mandatory fields are filled in order to proceed with the optimization. Any line items with blank mandatory fields will be omitted.",
    "media.plan.optimization.mandatory.fields":
      "Start date, End date, Vendor Product, Vendor, Program, Timebelt, Days of Week, Target A, GRP A",
    "media.plan.pre.evaluation.title": "Fetch Pre-evaluation",
    "media.plan.pre.evaluation.subtitle":
      "Select a date range to pre-evaluate your Media Plan",
    "modal.pre.eval.field.dateRange": "Date Range",
    "media.plan.pre.evaluation.mandatory.message":
      "Pre-evaluation cannot be completed at the moment. Please make sure there is at least one line item added in order to proceed.",
    // OXYGEN ERRORS
    "error.campaign.hasNoCopies": "Campaign has no copies",
    "error.cannot.toggle.association.copy":
      "Unable to delete: Copy in use in a Line Item",

    "bo.export": "Export BO (official)",
    "bo.export.amendment": "Export Amendment Advice",
    "bo.export.whole": "Export whole BO (with changes)",
    "bo.export.sbs": "Export Amendment Advice (side by side)",
    "bo.post.to.meta": "Initial post Campaign to Meta",
    "bo.post.to.meta.campaign.success":
      "A Meta campaign and its adset(s) were created successfully!",
    "bo.post.to.meta.adsets.success":
      "The Meta adset(s) were created successfully!",
    "export.bo.modal.title": "Export Booking Order",
    "export.bo.modal.subtitle":
      "Export the official version to be sent to the Media Owner.",
    "export.bo.modal.title.aa": "Export BO’s Amendment Advice",
    "export.bo.modal.subtitle.aa":
      "Select an older BO version you wish to compare and export the changes.",
    "export.bo.modal.title.whole":
      "Export Booking Order (whole BO with highlighted changes)",
    "export.bo.modal.subtitle.whole":
      "Select an older BO version you wish to compare and customize the settings for export",
    "export.bo.modal.export": "Export",
    "export.bo.modal.contact": "Contact Person",
    "export.bo.modal.remarks": "Remarks",
    "export.bo.modal.displayName": "Display Line Item Name",
    "export.bo.modal.displaySpotTotals": "Display Spot Totals/Spot Type",
    "export.bo.modal.version": "BO Version",
    "export.bo.modal.version.label": "Version",

    "bo.intercompany.company": "Company",

    "filter.by.buying_status": "Buying Status",

    grossCost: "Total Gross Cost",
    netCost: "Net Cost",

    status: "Status",

    "market.billingTypes.addSubBillingType": "Add Sub-Billing Type",
    "market.addSubbilingTypeBtn": "Add Sub-Billing Type",
    "market.addSubBillingType.done": "Done",

    "admin.billingTypes.subBillingType.add": "Add",
    "admin.billingTypes.subBillingType.edit": "Edit",
    "admin.billingTypes.billingSubtypes.more": "more",

    "create.bo.modal.filter.BILLING_TYPE": "Per Billing Type",
    "create.bo.modal.billingType": "Billing Type",
    "create.bo.modal.all.billingTypes": "All Billing Types",
    "admin.timeZone.title": "General",
    "admin.timeZone.currency": "Currency: ",
    "admin.timeZone.picker": "Time Zone: ",
    "inputs.timeZone.placeholder": "Time Zone",
    "autocomplete.label.timeZone": "Time Zone",
    "admin.billingTypes.tittle": "Billing Type",
    "admin.billingTypes.subBillingType.viewMore": "view more",
    "admin.billingTypes.subBillingType.viewLess": "view less",

    "filter.by.billingType": "Billing Type",

    "admin.copyQualities.title": "Copy Qualities",
    "admin.copyQualities.activate.title": "Activate Copy Quality",
    "admin.copyQualities.activate.description":
      "Are you sure you want to activate this copy quality?",
    "admin.copyQualities.deactivate.title": "Deactivate Copy Quality",
    "admin.copyQualities.deactivate.description":
      "Are you sure you want to deactivate this copy quality?",
    "market.copyQualities.empty.table": "No Copy Qualities",
    "market.copyQualities.add.row": "Add New",
    "market.copyQualities.modal.delete.title": "Delete Copy Quality",
    "market.copyQualities.modal.delete.description":
      "Are you sure you want to delete this copy quality?",
    "market.copyQualities.add.new.name": "Name",
    "market.copyQualities.add.new.factor": "Factor",
    "market.copyQualities.add.new.description": "Description",

    "admin.creativeAgencies.title": "Creative Agencies",
    "admin.creativeAgencies.activate.title": "Activate Creative Agency",
    "admin.creativeAgencies.activate.description":
      "Are you sure you want to activate this creative agency?",
    "admin.creativeAgencies.deactivate.title": "Deactivate Creative Agency",
    "admin.creativeAgencies.deactivate.description":
      "Are you sure you want to deactivate this creative agency?",
    "market.creativeAgencies.empty.table": "No Creative Agencies",
    "market.creativeAgencies.add.row": "Add New",
    "market.creativeAgencies.modal.delete.title": "Delete Creative Agency",
    "market.creativeAgencies.modal.delete.description":
      "Are you sure you want to delete this creative agency?",
    "market.creativeAgencies.add.new.name": "Name",
    "market.creativeAgencies.add.new.rut": "RUT",
    "market.creativeAgencies.add.new.code": "Code",

    vendor: "Vendor",
    vendorProduct: "Vendor Product",
    billingType: "Billing Type",

    "plan.button.post.items": "Post line items",
    "plan.button.post.to.meta": "Post to Meta",
    "bo.post": "Post",
    "bo.post.to.isap": "Post to ISAP",
    "status.POSTED": "Posted",
    "bo.posted": "The booking order has been posted!",
    "bo.unposted": "The booking order has been unposted!",
    "bo.unpost.success": "The booking order has been unposted!",
    "bo.unpost.error": "The action could not be completed due to errors",

    "filter.by.status": "Status",

    "modal.label.apply.local.copy": "Apply",
    "media.plan.local.copy.title": "Pending changes",
    "media.plan.local.copy.description":
      "A local copy, with pending changes, was found. Do you wish to apply those changes?",

    "media.plan.navigate.block.title": "Unsaved changes warning",
    "media.plan.navigate.block.description":
      "There are unsaved changes. Are you sure you wish to leave and discard those?",

    "table.plan.calendar.toggle.button": "Calendar View",
    "table.plan.timeline.customize.button": "Customize",
    "customize.plan.timeline.view.options": "View Options",
    "customize.plan.timeline.title": "Customize Calendar View",

    "planning.values": "Planning",

    "admin.mediaTypes.required": "Required Value",

    "customize.plan.timeline.indicators": "Gantt Chart Indicators",

    "modal.label.navigate.anyway": "Discard and Leave",
    "media.plan.navigate.block.save.and.exit": "Save and Leave",

    //revenue
    "revenue.brand.All": "All",
    "revenue.brand.GCF": "GCF",
    "revenue.brand.RedStream": "Red Stream",
    "revenue.brand.BlueStream": "Blue Stream",
    "revenue.brand.Silver Stream": "Silver Stream",
    "revenue.brand.Magenta Stream": "Magenta Stream",
    "revenue.brand.Mediahub": "Mediahub",
    "revenue.brand.Media Activation": "Media Activation",
    "revenue.responseRate": "Response Rate",
    "revenue.Delta": "Delta",
    "revenue.trr": "TRR",
    "revenue.grid.Revenue": "Revenue",
    "revenue.grid.yearly": " Yearly",
    "revenue.grid.monthly": " Monthly",
    "tbg.revenue.variance": "TBG REVENUE VARIANCE ($)",
    "revenue.grid.allOther": "All Other TBG",
    "revenue.grid.Onion": "Onion TBG",
    "revenue.net.rev": "NET REVENUE ($)",
    "revenue.variance": "REVENUE VARIANCE (%)",
    "net.revenue.variance.dollars": "NET REVENUE VARIANCE ($)",
    "net.revenue.variance.perc": "NET REVENUE VARIANCE (%)",
    "oibia.variance": "OIBIA VARIANCE (%)",
    "revenue.oibia": "OIBIA",
    "revenue.oibia.map": "OIBIA %",
    "revenue.oibia.grid": "OIBIA ($)",
    "revenue.oibia.margin": "OIBIA MARGIN (%)",
    "revenue.tbg.revenue": "TBG Revenue",
    "revenue.plain.tbg": "TBG",
    "revenue.delta.revenue": "Δ REVENUE ",
    "revenue.delta.oi": "Δ OIBIA",
    "revenue.revenue.oi": "Δ REVENUE / Δ OIBIA%",
    "revenue.usd.oi": "USD ($) / OIBIA (%)",
    "revenue.tbg": "TBG REVENUE ($)",
    "revenue.tbg.of.revenue": "TBG OF REVENUE (%)",
    "revenue.tbg.variance": "TBG REVENUE VARIANCE ($)",
    "revenue.current.re": "Current RE",
    "revenue.years.budget": "B/(W) vs. Current Year's Budget",
    "revenue.yearsbudget": "B/(W) vs.",
    "revenue.last.years.actual": "B/(W) vs. Last Year's Actual",
    "revenue.lastyearsactual": "B/(W) vs.",
    "revenue.years.actual": "B/(W) vs. 2 Year's Actual",
    "revenue.total.tbg.of.revenue": " TOTAL TBG & OF NET REVENUE",
    "Revenue.btn.clients": "Clients",
    "Revenue.btn.agencies": "Streams",
    "REVENUE.BTN.SBUS": "SBU",
    "revenue.oi.percent": "OI%",
    "revenue.revenue": "Revenue",
    "revenue.billings": "Billings",
    "revenue.yoybillingrowth": "YoY Billing Growth",
    "revenue.noRevenue": "N/A YoY Revenue Growth.",
    "revenue.noBilling": "N/A YoY Billing Growth.",
    "revenue.current": "Current",
    "revenue.previous": "Previous",
    "revenue.previous.year": "Previous Year",
    "revenue.previous.two.year": "Previous 2 Years",
    "revenue.prior": "Prior",
    "revenue.target": "Target",
    "revenue.ytd": " YTD ",
    "revenue.ytdRevenue": "YTD Revenue",
    "revenue.ytdOI": "YTD OI%",
    "revenue.bud": "Budget",
    "revenue.act": "ACT",
    "revenue.title.bud": "BUD",
    "revenue.fp": "FP",
    "revenue.vs": "vs.",
    "revenue.dollars": "IN DOLLARS ($)",
    "revenue.total": "Total",
    "revenue.usd": "USD ($)",
    "revenue.oi": "OI (%)",
    "revenue.no.data": "No data to display.",
    "revenue.select": "Select ",
    "revenue.error.title": "Oops",
    "revenue.error.subTitle": "There was en error. Please try again later",
    "revenue.noData.title": "No data to show",
    "revenue.noData.subTitle":
      "Try adjusting the filters to find what you are looking for",

    // billing
    invoices: "Invoices",
    "invoices.list.new_client_invoice": "New Client Invoice",
    "invoices.list.new_vendor_invoice": "New Vendor Invoice",
    "invoices.list.empty.title": "No invoices to display",
    "invoices.list.name": "Name",
    "invoices.list.status": "Status",
    "invoices.list.client": "Client",
    "invoices.list.payment_terms": "Payment Terms",
    "invoices.list.invoice_date": "Invoice Date",
    "invoices.list.due_date": "Due Date",
    "invoices.list.actions": "Actions",
    "invoice.actions.delete": "Delete",
    "invoice.actions.delete.title": "Delete Invoice",
    "invoice.actions.delete.description":
      "Are you sure you want to delete this invoice?",
    "invoice.actions.delete.submit": "Delete",
    "invoice.details.table.title": "Items",
    "invoice.details.button.add_items": "Add New",
    "invoice.details.items.empty.title": "No items to display",
    "invoice.details.remarks.label": "Remarks",
    "invoice.details.remarks.placeholder": "Add a note to client...",
    "invoice.details.remarks.description": "Leave blank for empty",
    "invoice.items.list.name": "Item",
    "invoice.items.list.status": "Status",
    "invoice.items.list.remaining_to_bill": "Remaining To Bill",
    "invoice.items.list.billing_type": "Billing Type",
    "invoice.items.list.start_date": "Start Date",
    "invoice.items.list.amount_percentage": "Amount / Percentage",
    "invoice.modal.add_billable_items": "Add Items to Invoice",
    "invoice.add_items.cancel": "Cancel",
    "invoice.add_items.submit": "Add Items to Invoice",
    "invoice.empty.title": "No invoice to display",
    "status.ISSUED": "Issued",
    "status.PARTIALLY_PAID": "Partially Paid",
    "status.PAID": "Paid",
    "status.EXPIRED": "Expired",
    "invoice.details.header.number": "Number",
    "invoice.details.header.client": "Client",
    "invoice.details.header.preview": "Preview",
    "invoice.details.header.details": "Details",
    "invoice.details.items.selected": "selected",
    "invoice.items.button.deselect_all": "deselect all",
    "invoice.items.button.delete": "Delete",
    "invoice.details.summary": "Invoice Summary",
    "invoice.details.drawer.title": "Invoice Details",
    "invoice.details.drawer.details": "Details",
    "invoice.details.drawer.private_notes": "Private Notes",
    "invoice.details.drawer.attached_files": "Attached Files",
    "invoice.details.drawer.activity": "Activity",
    "invoice.details.general_info": "General Info",
    "invoice.details.client": "Client",
    "invoice.details.bill_to_client": "Bill to Client",
    "invoice.details.invoice_type": "Invoice Type",
    "invoice.details.invoice_date": "Invoice Date",
    "invoice.details.payment_terms": "Payment Terms",
    "invoice.details.payment_terms_suffix": "days",
    "invoice.details.campaign": "Campaign",
    "invoice.campaigns.more": "more",
    "invoice.details.product": "Product",
    "invoice.products.more": "more",
    "invoice.details.po_number": "PO Number",
    "invoice.details.media_plan": "Media Plan",
    "invoice.media_plans.more": "more",
    "invoice.details.booking_orders": "BO",
    "invoice.booking_orders.more": "more",
    "invoice.details.media_type": "Media Type",
    "invoice.media_types.more": "more",
    "invoice.details.financial_category": "Financial Category",
    "invoice.details.document_date": "Issued Date",
    "invoice.details.disposition_code": "Disposition Code",
    "invoice.details.cost_center": "Cost Center",
    "invoice.details.profit_center": "Profit Center",
    "invoice.details.private_notes.label": "Personal Notes",
    "invoice.details.private_notes.placeholder": "Add notes...",
    "invoice.details.private_notes.description":
      "These notes are visible to people only with access to this invoice. They are not displayed in the actual invoice",
    "nav.invoices.create_client_invoice": "Create Client Invoice",
    "nav.billing": "Billing",
    "nav.invoices": "Invoices",
    "nav.invoice": "Invoice",
    "invoices.create_client_invoice": "Create Client Invoice",
    "invoices.new_invoice.cancel": "Cancel",
    "invoices.new_invoice.create": "Create Invoice",
    "invoice.partial_billing": "Partial Billing",
    "billable_item.already_billed": "Already Billed",
    "invoice.type.option.NORMAL": "Normal",
    "invoice.type.option.PRE_BILL": "Pre-Bill",
    "billable_items.filters.booking_orders": "BO",
    "billable_items.filters.media_plans": "Media Plan",
    "billable_items.filters.campaign": "Campaign",
    "billable_items.filters.client_agency_config": "Client",
    "billable_items.filters.date_posted": "Date Posted",
    "billable_items.filters.date_range": "Date Range (Items)",
    "billable_items.filters.product": "Product",
    "billable_items.filters.vendor": "Vendor",
    "billable_items.filters": "Filters",
    "billable_items.clear_filters": "Clear Filters",
    "billable_items.table.empty.title": "No Billable Items to display",
    "billable_items.table.empty.subtitle":
      "We couldn't find any billable items matching your criteria",
    "billable_item.name": "Name",
    "billable_item.status": "Status",
    "billable_item.remaining_to_bill": "Remaining to Bill",
    "billable_item.media_type": "Media Type",
    "billable_item.billing_type": "Billing Type",
    "billable_item.budget": "Budget",
    "billable_item.vendor": "Vendor",
    "billable_item.start_date": "Start Date",
    "billable_item.end_date": "End Date",
    "billable_item.amount_percentage": "Amount / Percentage",
    "billable_items.total_amount": "Total Amount",
    "billable_items.selected": "selected",
    "invoice.documents.description": "a file",
    "invoice.documents.other": "Other",
    "invoice.documents.delete.prompt": "Delete File?",
    "invoice.documents.delete.confirm": "Delete",
    "passthrough.costs.dialog.title": "Passthrough Costs",
    "passthrough.costs.dialog.guide":
      "Select to add multiple costs. Amount / percentage of the cost can be overwritten. You can always reset to default settings by simply pressing the reset button.",
    "passthrough.costs.columns.label": "Label",
    "passthrough.costs.columns.type": "Type",
    "passthrough.costs.columns.amount": "Amount",
    "actions.apply": "Apply",
    "actions.proceed": "Proceed",

    "drag.n.drop": "Drag and drop",

    "exclusions.select.date": "Select Date",

    "clients.list.company": "Company",
    "agency.client.company": "Company",

    "line.item.split.title": "Split Line Item",
    "line.item.split.date.monthly": "Monthly",
    "line.item.split.date.quarterly": "Quarterly",
    "line.item.split.date.custom": "Custom...",
    "line.item.split.date.month": "Month",
    "line.item.split.date.quarter": "Quarter",
    "line.item.split.date.startDate": "Start Date",
    "line.item.split.date.endDate": "End Date",
    "line.item.split.table.empty": "No Dates",
    "line.item.split": "Split",
    "line.item.split.date.add": "Add Date",
    "split.frame.monthly": "Monthly",
    "split.frame.quarterly": "Quarterly",

    "markup.tooltip": "Markup",

    "role.BILLER": "BILLER",
    "billable_item.item": "Item",
    "billable_item.spots": "Spots",
    "billable_item.this_invoice": "This Invoice",
    "billable_item.net_cost": "Net Cost",
    "billable_item.agency_fees": "AC Fees",
    "billable_item.agency_commissions": "Agency Commission",
    "billable_item.media_fees": "Vendor Passthrough Cost",
    "invoice.details.terms_and_conditions.label": "T&C's",
    "invoice.details.terms_and_conditions.placeholder":
      "Add a note to client...",
    "invoice.details.terms_and_conditions.description": "Leave blank for empty",
    "invoice_item.disposition_code": "Disposition Code",
    "invoice_item.profit_center": "Profit Center",
    "invoice_item.cost_center": "Cost Center",
    "billable_item.tax_select": "Tax (%)",
    "billable_item.agency_taxes": "AC Tax",
    "billable_item.media_taxes": "MC Tax",
    "billable_item.tax_value": "Tax Value",
    "billable_item.total_billable": "Total Billable",
    "inputs.exchange_rate": "Exchange rate",
    "billable_item.spots_modal.spot_analysis": "Spot Analysis",
    "billable_item.spots_modal.total_remaining_to_bill":
      "Total Remaining to Bill",
    "billable_item.spots_modal.spot_date": "Date",
    "billable_item.spots_modal.to_bill": "Bill",
    "billable_item.spots_modal.actions.close": "Close",
    "invoice.actions.bill": "Bill to Client",
    "invoice.actions.bill.title": "Bill Invoice to Client",
    "invoice.actions.bill.description":
      "Are you sure you want to bill this invoice to the client? No further changes can be made after this step.",
    "invoice.actions.bill.submit": "Bill to Client",
    "activity.CREATE_INVOICE": "Invoice Creation",
    "activity.EDIT_INVOICE": "Invoice Edit",
    "activity.BILL_INVOICE": "Invoice Bill",
    "activity.DELETE_INVOICE": "Invoice Deletion",

    "invoice.details.charges-selector": "Invoice charges",
    "invoice.details.taxes-selector": "Tax",
    "invoice.details.charges-title": "Invoice charges",
    "invoice.details.taxes-title": "Tax",

    "no.passthough.options": "No passthrough cost options are available",
    "invoices.list.empty.subtitle":
      "Start now creating the first one by clicking",
    "invoices.list.empty.or": "or",
    "nav.invoices.create_vendor_invoice": "Create Vendor Invoice",
    "invoices.create_vendor_invoice": "Create Vendor Invoice",
    "invoice.vendor.received_invoice_no": "Received Invoice No",
    "billable_item.total_amount_to_pay": "Total Amount to Pay",
    "billable_item.remaining_to_pay": "Remaining to Pay",
    "billable_item.tax": "Tax",
    "billable_item.media_tax_percentage": "MC Tax (%)",
    "billable_item.media_tax_value": "MC Tax value",
    "invoice.details.vendor": "Vendor",
    "invoice.details.pay_to_vendor": "Pay to Vendor",
    "invoice.actions.submit": "Submit",
    "invoice.actions.submit.title": "Submit invoice",
    "invoice.actions.submit.description":
      "Are you sure you want to submit this invoice? No further changes can be made after this step.",
    "invoice.details.header.vendor": "Vendor",

    "invoices.list.number": "Number",
    "invoices.list.campaigns": "Campaign",
    "invoices.list.products": "Product",
    "invoices.list.vendor": "Vendor",
    "invoices.documents.other": "Other",
    "invoice_summary.total_gross_cost": "Total Gross Cost",
    "invoice_summary.media_commissions": "Media Commissions",
    "invoice_summary.total_net_cost": "Total Net Cost",
    "invoice_summary.agency_commissions": "Agency Commission",
    "invoice_summary.agency_fees": "AC Fees",
    "invoice_summary.media_fees": "Vendor Passthrough Costs",
    "invoice_summary.taxes": "Taxes",
    "invoice_summary.total_billable": "Total Billable",
    "invoice_summary.total_before_rounding": "Total Before Rounding",
    "invoice_summary.rounding_adjustment": "Rounding Adjustment",

    "plan.button.daysOffset": "Move dates",
    "daysOffset.action.title":
      "Move selected items in time by an offset in days",
    "daysOffset.pick.direction": "Select to offset to the",
    "daysOffset.direction.for": "future",
    "daysOffset.direction.back": "past",
    "daysOffset.pick.offset": "Pick the offset in days",
    "daysOffset.notes":
      "By clicking the Submit button all selected items will be have their start and end dates moved by the chosen offset in days. For items that have spots, the spot dates will be moved accordingly as well.",

    "name.copy.of": "Copy",
    "invoice.type.option.CREDIT_NOTE": "Credit Note",
    "billable_items.filters.invoice": "Invoice",
    "billable_items.filters.billing_type": "Billing Type",
    "status.BILLED": "Billed",

    "invoice.details.company": "Company",
    "invoice.po_number.more": "more",
    "billable_item.unbill": "Unbilled Amount",
    "billable_items.filters.company": "Company",

    "status.UNBILLED": "Unbilled",
    "invoice.scope.CLIENT": "Client",
    "invoice.scope.VENDOR": "Vendor",
    "filters.invoice_type": "Type",
    "filters.invoice_scope": "Scope",
    "table.invoices.filters.title": "Filter Invoices",
    "billable_item.unbilled": "Unbilled Amount",
    "invoices.list.company": "Company",
    "invoices.list.type": "Type",
    "nav.credit_note": "Credit Note",
    "invoice.details.invoice_ref_no": "Invoice Reference No",
    "invoice.vendor.invoice_ref_no": "Invoice Reference No",
    "invoices.list.invoiceRefNo": "iSAP Number",
    "number.trillion": "trillion",
    "number.billion": "billion",
    "number.million": "million",
    "number.thousand": "thousand",
    "number.nine-hundred": "nine hundred",
    "number.eight-hundred": "eight hundred",
    "number.seven-hundred": "seven hundred",
    "number.six-hundred": "six hundred",
    "number.five-hundred": "five hundred",
    "number.four-hundred": "four hundred",
    "number.three-hundred": "three hundred",
    "number.two-hundred": "two hundred",
    "number.one-hundred": "one hundred",
    "number.ninety": "ninety",
    "number.eighty": "eighty",
    "number.seventy": "seventy",
    "number.sixty": "sixty",
    "number.fifty": "fifty",
    "number.forty": "forty",
    "number.thirty": "thirty",
    "number.twenty": "twenty",
    "number.nineteen": "nineteen",
    "number.eighteen": "eighteen",
    "number.seventeen": "seventeen",
    "number.sixteen": "sixteen",
    "number.fifteen": "fifteen",
    "number.fourteen": "fourteen",
    "number.thirteen": "thirteen",
    "number.twelve": "twelve",
    "number.eleven": "eleven",
    "number.ten": "ten",
    "number.nine": "nine",
    "number.eight": "eight",
    "number.seven": "seven",
    "number.six": "six",
    "number.five": "five",
    "number.four": "four",
    "number.three": "three",
    "number.two": "two",
    "number.one": "one",
    "number.zero": "zero",
    "number.and": "and cents",
    "number.minus": "minus",
    "number.only": "only",
    "input.exchangeRate": "Exchange Rate",
    "input.budgetInUSD": "Budget in USD",
    "input.budgetInCampaignCurrency": "Budget in Campaign Currency",
    "invoice.preview.a-division-of": "A division of",
    "invoice.preview.print": "PRINT",
    "invoice.preview.sst-No": "SST Registration No",
    "invoice.preview.bill-to": "Bill To",
    "invoice.preview.invoiceNo": "Invoice No",
    "invoice.preview.summary": "SUMMARY",
    "invoice.preview.item": "Item",
    "invoice.preview.spots": "Spots",
    "invoice.preview.gross-cost": "Gross Cost",
    "invoice.preview.media-commissions": "Media Commissions",
    "invoice.preview.net-cost": "Net Cost",
    "invoice.preview.agency-commission": "Agency Commission",
    "invoice.preview.agency-fees": "AC Fees",
    "invoice.preview.media-fees": "Vendor Passthrough Cost",
    "invoice.preview.taxes": "Taxes",
    "invoice.preview.total-billable": "Billable Amount",
    "invoice.preview.currency": "Currency",
    "invoice.preview.exchange-rate": "Exchange Rate",
    "invoice.preview.related-info": "Invoice Related Info",
    "invoice.preview.campaigns": "Campaigns",
    "invoice.preview.schedule-No": "Schedule No",
    "invoice.preview.purchase-No": "Purchase No",
    "invoice.preview.product": "Product",
    "invoice.preview.remarks": "Remarks",
    "invoice.preview.terms-and-conditions": "Terms & Conditions",
    "invoice.preview.payment-details": "Payment Details",
    "invoice.preview.date": "Date",
    "invoice.preview.agency-discount": "Agency Discount",
    "invoice.preview.production-cost": "Production Cost",
    "invoice.preview.amount": "Amount",

    "filters.campaign": "Campaign",
    "billable_item.already_paid": "Already Paid",
    "invoices.list.media_plan": "Media Plan",
    "invoices.list.total_billable_payable": "Total Billable/Payable",
    "filters.createdBy": "Created By",
    "invoice.created_by": "Created By",

    "billable_item.available_for_credit": "Available for credit",

    "invoice.actions.realize": "Reverse",
    "invoice.bar.realize.description":
      "Invoice items have no remaining unbilled amount",
    "billable_item.unbilled.original": "Original",
    "billable_item.unbilled.remaining": "Remaining",
    "invoice.modal.realize.header": "Reverse Invoice",
    "invoice.modal.realize.description":
      "Please enter the required details to continue",
    "invoice.realize.disposition_code": "Disposition Code",
    "invoice.realize.reference_date": "Invoice Date",
    "invoice.realize.document_date": "Issued Date",
    "invoice.realize.invoiceRefNo": "Invoice Reference No",
    "invoice.details.realize_info": "Reverse info",
    "financial.summarized.grossCost": "Total Gross Cost",
    "financial.summarized.mediaCommissions": "Media Commission",
    "financial.summarized.netCost": "Total Net Cost",
    "financial.summarized.billable": "Total Payable",
    "financial.summarized.agencyCommissions": "Agency Commission",
    "financial.summarized.fees": "Fees",
    "financial.summarized.taxes": "Taxes",
    "financial.summarized.passthroughCosts": "Passthrough Costs",
    "financial.summarized.totals": "Totals",

    "bo.items.posted": "The booking items have been posted!",
    "bo.items.unposted": "The booking items have been unposted!",
    "client.agency.config.id.missmatch":
      "Selected billable items belong to multiple clients",
    "financial.summary.empty": "There are no line items to summarize",
    "digital.calculator.enabled": "Use Digital Calculator",
    "financial.summarized.netCostMarkup": "Net Cost Markup",
    "financial.summarized.passthroughMarkup": "Passthough Costs Markup",

    "invoice.dispositionId.more": "more",
    "invoice.costCenterId.more": "more",
    "invoice.profitCenterId.more": "more",
    "modal.fetch.rankings.title": "Fetch Rankings",
    "modal.fetch.rankings.subtitle":
      "Select from the below parameters to fetch the rankings",
    "modal.fetch.rankings.alert":
      "This action cannot be completed, because this Media Plan must contain at least one target.",
    "modal.rankings.field.dateRange": "Date Range",
    "modal.rankings.type": "Ranking Type",
    "modal.rankings.punishment.rate": "Punishment Rate (optional)",
    "modal.rankings.table.subtitle":
      "Select from the below Programs and apply your selection",
    "rankings.table.column.channel": "Channel",
    "rankings.table.column.program": "Program",
    "rankings.table.column.type": "Ranking Type",
    "rankings.table.column.day": "Day",
    "rankings.table.column.day.more": "more",
    "rankings.table.column.time": "Time",
    "rankings.table.column.targetA": "Target A",
    "rankings.table.column.targetB": "Target B",
    "rankings.table.column.grpTargetA": "GRP Target A",
    "rankings.table.column.grpTargetB": "GRP Target B",
    "rankings.table.column.cpp": "CPP 30°",
    "rankings.table.column.negotiated.value": "Negotiated Value",
    "rankings.noresults.title": "No rankings to display",
    "rankings.apply.title": "Fetch Rankings",
    "rankings.apply.description.line1":
      "By applying the new Rankings all the items from your Media Plan will be deleted and cannot be recovered.",
    "rankings.apply.description.line2": "Are you sure you want to proceed?",
    "rankings.apply.action": "Apply",
    "rankings.filter.label": "Filter the table",
    "rankings.filter.channel": "Channel",
    "rankings.filter.program": "Program",
    "rankings.filter.targetA": "Target A",
    "rankings.filter.targetB": "Target B",
    "rankings.filter.type": "Ranking Type",
    "rankings.filter.days": "Days of Week",

    "mediaplan.overview.targets": "Targets",
    "mediaplan.overview.targetA": "Target A",
    "mediaplan.overview.targetB": "Target B",

    "plan.new.mediatypes.header.targetA": "Target A",
    "plan.new.mediatypes.header.targetB": "Target B",

    "invoice.details.isap-fields-selector": "ISAP fields",
    "invoice.details.isap-fields-title": "ISAP fields",
    "actions.select": "Select",

    "admin.i18n.error":
      "The file upload failed! Please check if the file is a valid json file.",

    "error.submitUnbilledInvoice.invalidDC":
      "Disposition code must be FE for all unbilled items to submit the invoice",
    "disposition.must.be.EE":
      "Disposition code must be EE to reverse the invoice",
    "market.taxes.header": "Taxes",
    "taxes.list.activate.action": "Activate",
    "taxes.list.deactivate.action": "Deactivate",
    "create.tax.input.erpCode": "ERP Code",
    "create.tax.input.label": "Label",
    "create.tax.input.taxUsage": "Tax Usage",
    "create.tax.input.invoiceScope": "Scope",
    "tax.invoiceScope.client": "Client",
    "tax.invoiceScope.vendor": "Vendor",
    "admin.taxes.activate.title": "Activate Tax",
    "admin.taxes.activate.description":
      "Are you sure you want to activate this Tax?",
    "admin.taxes.deactivate.title": "Deactivate Tax",
    "admin.taxes.deactivate.description":
      "Are you sure you want to deactivate this Tax?",
    "market.tax.exempt.header": "Tax Exempt",
    "market.invoiceRounding.header": "Invoice Rounding",
    "market.invoiceRounding.upperLimit": "Absolute Upper Limit",
    "add.dynamic.content": "Add dynamic content",
    "no.targets.overview": "No Targets to display yet",

    "activity.REALIZE": "Invoice Reverse",
    "intercompany.values": "Intercompany",
    "reporting.create_report": "Report Builder",
    "invoice.preview.taxExempt": "Service Tax Exempt",
    "invoice.preview.print.taxExempt": "Print the Tax Exemption text",

    "billable_item.booking_order": "Booking Order",
    "billable_item.media_plan": "Media Plan",
    "billable_item.campaign": "Campaign",
    "billable_item.client": "Client",
    "invoice.new.different_clients.warning.description":
      "The selected items refer to different clients",
    "invoice.new.different_vendors.warning.description":
      "The selected items refer to different vendors",
    "invoice.new.different_clients_and_vendors.warning.description":
      "The selected items refer to different vendors and clients",

    "reporting.templates": "Templates",
    "reporting.export-report": "Export Report",
    "reporting.save-template": "Save Template",
    "reporting.reset-template": "Reset",
    "reporting.template.load.title": "Templates",
    "reporting.template.load.subtitle":
      "Please select a template from the list.",
    "reporting.templates.column.title": "Templates",
    "reporting.templates.column.actions": "Actions",
    "reporting.button.cancel": "Cancel",
    "reporting.button.use": "Use Template",
    "reporting.template.save.title": "Save Template",
    "reporting.template.input.name": "Template Name",
    "reporting.button.create": "Save Template",

    "document.too.big": "The document's size exceeds the max limit.",
    "invoice.details.pay_to_client": "Pay To Client",
    "invoice.details.bill_to_product": "Bill To Product",
    "invoice.details.pay_to_product": "Pay To Product",

    "change.vendor.confirmation.title": "Change Item Vendor",
    "plan.button.change.vendor": "Change Vendor",
    "plan.submit.change.vendor": "Apply",
    "select.a.vendor": "Select a Vendor",
    "no.lines.selected": "There are no selected items",
    "vendor.owner.not.selected": "The media owner cannot be determined",
    "selected.lines.have.different.media.owner":
      "The selected lines do not share the same media owner",
    "short.days.MONDAY": "MO",
    "short.days.TUESDAY": "TU",
    "short.days.WEDNESDAY": "WE",
    "short.days.THURSDAY": "TH",
    "short.days.FRIDAY": "FR",
    "short.days.SATURDAY": "SA",
    "short.days.SUNDAY": "SU",
    "no.vendor.is.selected": "No vendor is selected",
    "change.vendor.warning":
      "If you proceed, changes will be made to the Booking Orders of this Media Plan and the selected line items will return to the Approved status.",
    "billable_item.product": "Product",

    "invoice.rounding": "Invoice Rounding",
    "invoice.rounding.amount": "Amount",
    "invoice.rounding.correction": "Correction",

    "invoices.list.new_invoice": "New Invoice",
    "invoices.list.new_settle_invoice": "New Settle Invoice",
    "invoices.create_settle_invoice": "Create Settle Invoice",
    "nav.invoices.create_settle_invoice": "Create Settle Invoice",
    "invoice.scope.SETTLE": "Settle",
    "billable_item.markup_net_cost": "Markup on Net Cost",
    "billable_item.markup_media_fees": "Markup on Passthrough Costs",
    "billable_item.remaining_to_settle": "Remaining to Settle",
    "billable_item.already_settled": "Already settled",
    "billable_item.total_markup": "Total Markup",
    "invoice_summary.markup_net_cost": "Markup on Net Cost",
    "invoice_summary.markup_media_fees": "Markup on Passthrough Costs",
    "invoice_summary.total": "Total",
    "status.SUBMITTED": "Submitted",
    "error.settle.invoice.mandatory.fields":
      "Missing mandatory fields. Mandatory fields are: Disposition Codes, Bill to Product",
    "mediaplan.tabs.spots.summary": "Spots",
    "media.plan.spots.summary.noresults.title": "No Spots available yet",

    "bo.official": "Mark as Official",
    "bo.modal.official.action": "Yes, Mark",
    "bo.modal.official.title": "Mark as official",
    "bo.modal.official.description":
      "Are you sure you want to mark this BO as official?",
    "bo.details.display.version": "Display Version",
    "bo.details.official.version": "Official Version",
    "bo.details.official.version.based.on": "Based on Display V",

    "match.spots.button": "Post Evaluate",
    "auto.match.spots.button": "Automatic Matching",
    "market.max.spot.matching.tolerance": "Maximum Spot Matching Tolerance",
    "market.max.spot.matching.tolerance.info.message":
      "Maximum Spot Matching Tolerance Allowed:",
    "market.max.spot.matching.tolerance.info.message.time.unit": "Minutes",
    "market.max.spot.matching.tolerance.modal.title":
      "Maximum Spot Matching Tolerance",
    "market.max.spot.matching.tolerance.modal.message":
      "Are you sure you want to set the Maximum Spot Matching Tolerance to ",
    "market.max.spot.matching.tolerance.modal.button": "Confirm",
    "market.max.spot.matching.tolerance.input.error.message":
      "The value must be between 0 and 60",
    "market.max.spot.matching.tolerance.input.error.service":
      "Something went wrong. Please try again.",
    "auto.match.failed": "The automatic matching failed",
    "auto.match.success": "The automatic matching is completed",
    "post.eval.failed": "The post evaluation failed",
    "post.eval.success": "The post evaluation is completed",
    "generic.more": "more",
    "data.integrity.error": "No value present",

    "mediaplan.tabs.lineItemsSummary": "Spot Counters",
    "spots.export.failed": "The plan spots export failed",
    "spot.action.manual_matching": "Manual Matching",
    "spot.matching.drawer.select_spot_that_matches":
      "Select the broadcasted spot that matches",
    "spot.matching.action.match_and_post_evaluate": "Match",
    "spot.matching.action.match": "Match",
    "spot.matching.proposal.externalId": "Spot id",
    "spot.matching.proposal.realDate": "Date",
    "spot.matching.proposal.realTime": "Time",
    "spot.matching.proposal.realDuration": "Duration",
    "spot.action.cannot_manual_match":
      "Manual Matching action cannot be completed",
    "spot.counters": "Spot Counters",
    "spot.counter.1": "Spot Counter 1",
    "spot.counter.2": "Spot Counter 2",
    "spot.counter.templates": "Templates",
    "spot.counter.save-template": "Save Template",
    "spot.counter.reset-template": "Reset",
    "spot.counter.template.save.title": "Save Template",
    "spot.counter.template.input.name": "Template Name",
    "spot.counter.button.cancel": "Cancel",
    "spot.counter.button.create": "Create",
    "spot.counter.template.load.title": "Templates",
    "spot.counter.template.load.subtitle":
      "Please select a template from the list.",
    "spot.counter.templates.column.title": "Templates",
    "spot.counter.templates.column.actions": "Actions",
    "spot.counter.button.use": "Use Template",

    "no.counters.created": "No Spot Counters are created",
    "spot.counter.template.manager.title": "Manage Spot Counters",
    "spot.counter.template.manager.subtitle":
      "Create new or configure existing spot counters",
    "counter.manager.button.create": "Create New",
    "counter.manager.button.close": "Close",

    "spot.counter.template.name": "Counter name",
    "spot.counter.template.save": "Save",
    "spot.counter.templates.column.enabled": "Enabled",
    "spot,counter.template.save": "Save",
    "mediaplan.taxes.dialog.title": "Tax Usage",
    "mediaplan.taxes.dialog.ac.title": "AC Tax",
    "mediaplan.taxes.dialog.mc.title": "MC Tax",
    "tax.usage.table.label": "Label",
    "tax.usage.table.erpcode": "ERP Code",
    "tax.usage.table.percentage": "Percentage",

    "media.plan.some.items.could.not.be.deleted":
      "Not all selected items were applicable for deletion. Those that were not are untouched.",

    "financial.summarized.taxesTotal": "Total Taxes",

    "spot.matching.proposal.vendorProduct": "Vendor Product",
    "spot.matching.proposal.program": "Program",
    "spot.matching.table.title": "Spot matching proposals:",
    "status.MATCHED": "Matched",
    "status.UNMATCHED": "Unmatched",

    "spot.counters.manage": "Manage",
    "spot.counters.title": "Counters",
    "spot.counters.add.new": "Add a New Counter",
    "spot.counter.template.add.title": "New Spot Counter",
    "spot.counter.template.add.subtitle": "Name and customize your new counter",
    "spot.counter.template.edit.title": "Edit Spot Counter",
    "spot.counter.template.edit.subtitle": "customize your counter",
    "spot.counter.edit": "Edit",
    "spot.counter.delete": "Delete",
    "bulk.some.failed":
      "The value could not be applied to some of the selected items due to non matching dependencies.",

    "spot.unmatch.failed": "The spot(s) could not be unmatched",
    "spot.action.unmatch": "Unmatch",
    "spots.total_summary.failed":
      "We couldn't fetch the total matched and unmatched spots.",

    "billable_item.total_remaining_to_bill": "Total Remaining to Bill",
    "billable_item.total_remaining_to_pay": "Total Remaining to Pay",
    "billable_item.total_remaining_to_settle": "Total Remaining to Settle",
    "billable_item.total_available_for_credit": "Total Available for Credit",
    "billable_item.bill": "Bill",
    "billable_item.pay": "Pay",
    "billable_item.settle": "Settle",
    "billable_item.credit": "Credit",

    "filters.copy": "Copy",
    "filters.program": "Program",
    "filters.channel": "Channel",
    "filters.program_hour_range": "Program Time Range",

    "edit.blocked.due.to.matched.spots":
      "Editing is blocked due to some spots being matched.",

    "filters.real_date_range": "Real Date Range",
    "filters.real_program_time_range": "Real Program Time Range",

    "media.plan/optimization.validation.error":
      "There are no copies at campaign level so the optimization cannot take place.",

    "spot.matching.proposal.noresults.title": "No Spots to display yet",

    "spot.matching.error.externalCopyNotFound":
      "The selected spot’s copy has not been found",
    "filters.actions.reset": "Reset filters",
    "plan.button.validate.programNames": "Validate Program Names",
    "program.names.validation.success":
      "Validate program names completed successfully",
    "program.names.validation.failed": "Program Names do not match",

    "status.POST_EVALUATED": "Post Evaluated",

    "bookingTable.title": "Booking Order Posting",
    "bookingTable.displayVersion": "Display Version",
    "bookingTable.status": "Status",
    "bookingTable.response": "Response",
    "bookingTable.date": "Date",
    "bookingTable.user": "User",

    "bo.cancel": "Cancel",
    "bo.cancel.view.details": "View Details",
    "bo.cancel.details": "Booking Order Details",
    "bo.cancel.details.details": "Details",
    "bo.cancel.details.comments": "Comments",
    "bo.cancel.details.files": "Attached Files",
    "bo.cancel.details.cancelled.by": "Canceled By",
    "bo.cancel.details.cancelled.date": "Canceled Date",
    "bo.cancel.details.cancelled.time": "Canceled Time",
    "bo.cancel.confirm.modal.title": "Cancel Booking Order",
    "bo.cancel.confirm.modal.titleReadOnly": "Booking Order Cancelation Detail",
    "bo.cancel.confirm.modal.description":
      "Are you sure you want to cancel this booking order?",
    "bo.cancel.confirm.modal.button": "Proceed with BO Cancelation",
    "bo.cancel.confirm.modal.textarea.placeholder": "Add Comment (Required)",
    "bo.cancel.confirm.modal.message":
      "Provide a comment and document(s) to support the Booking Order Cancelation.",
    "bo.cancel.submit.modal.title": "Cancel Booking Order",
    "bo.cancel.submit.modal.cancelledby": "Canceled By",
    "bo.cancel.submit.modal.cancellationDate": "Cancelation Date",
    "bo.cancel.submit.modal.cancellationTime": "Cancelation Time",
    "bo.cancel.submit.modal.comments": "Comments",
    "bo.cancel.submit.modal.fileAttachment": "File Attachment",
    "bo.cancel.submit.modal.files": "Cancelation files",
    "bo.cancel.submit.modal.files-error":
      "exceeded the maximum allowed size (1MB)",
    "bo.cancel.submit.modal.file": "a file",
    "bo.cancel.submit.modal.button": "Cancel Booking Order",
    "bo.cancel.submit.modal.error.date": "Date is required",
    "bo.cancel.submit.modal.error.time": "Time is required",
    "bo.cancel.submit.modal.error.file": "File is required",
    "bo.cancel.submit.modal.": "",
    "bo.cancel.close.modal": "Close",
    "bo.cancel.general.error": "Something went wrong! Please try again later.",
    "atb.actions.export": "Export",
    "atb.modal.calendarView": "Export calendar view",
    "atb.modal.daily": "Daily",
    "atb.modal.weekly": "Weekly",
    "atb.modal.description":
      "Please select the level of calendar granularity for the ATB export",

    "admin.exchange_rate.error.already_exits":
      "Exchange currency already exist",
    "admin.exchange_rate.error.unknown": "An unknown error occurred.",
    "admin.exchange_rate.error.creation": "Error creating exchange rate",
    "admin.exchange_rate.base_currency": "Base Currency",
    "admin.exchange_rate.select_base_currency": "Select base currency",
    "admin.exchange_rate.currency": "Currency",
    "admin.exchange_rate.select_currency": "Select currency",
    "admin.exchange_rate.exchange_rate": "Exchange Rate",
    "admin.exchange_rate.enter.exchange_rate": "Enter exchange rate",
    "admin.exchange_rate.cancel": "Cancel",
    "admin.exchange_rate.add": "Add",

    "admin.exchange_rate.delete": "Delete",
    "admin.exchange_rate.delete_exchange_rate": "Delete Exchange Rate",
    "admin.exchange_rate.confirm_deletion":
      "Are you sure you want to delete the exchange rate for",

    "admin.exchange_rate.new_exchange_rate": "+ New Exchange Rate",
    "admin.exchange_rate.none_exchange_rate": "No exchange rates available",
    "admin.exchange_rate.please_add_exchange_rate":
      "Please add new exchange rates",
    "admin.exchange_rate.delete_error_message":
      "There was an error deleting this Exchange Rate, Try again later",
    "admin.exchange_rate.update_success_message":
      "Exchange rate updated successfully",
    "status.POSTED_FOR_BILLING": "Posted for Billing",
    "mediaplan.tabs.matching": "Matching",

    "sub.media.type.value.not.available": "N/A",

    "matching.tolerance.spot.modal.main.title": "Set Matching Tolerance",
    "matching.tolerance.spot.modal.title":
      "Matching Tolerance will be applied to both Program Start Time and Program End Time.",
    "matching.tolerance.required.field": "Matching Tolerance*",
    "matching.tolerance.warning.message":
      "This action cannot be completed! A value must be set between 0 and",
    "matching.tolerance.warning.message.minutes": "minutes.",
    "matching.tolerance.info.message":
      "*Maximum Spot Matching Tolerance is Set to",
    "matching.tolerance.info.message.minutes": "Minutes",
    "spot.action.semiautomatic_matching": "Semi-Automatic Matching",
    "vendors.fields.rutNumber": "Vendor Tax Reg No",
    "spots.list.matchType": "Match Type",
    "spots.list.bookingOrderNumber": "BO Number",
    "status.CERTIFIED": "Certified",
    "status.SEMI_AUTOMATIC": "Semi-Automatic",
    "status.AUTOMATIC": "Automatic",
    "nav.support": "Support",
    "nav.support.market_initialization": "Market Initialization",
    "support.market_initialization.select_file": "Select a file",
    "support.market_initialization.perform_action": "Perform an action",
    "support.market_initialization.read_response": "Read the response",
    "support.market_initialization.drop_it": "Drop it like it's hot",
    "support.market_initialization.upload_xlsx":
      "Upload .XLSX - drop file here or click box to browse.",
    "support.market_initialization.validate": "Validate",
    "support.market_initialization.initialize": "Initialize",
    "support.market_initialization.download": "Download as a file",
    "support.market_initialization.template_ready":
      "Template is ready to be uploaded and run.",
    "support.market_initialization.market_initialized":
      "Market has been initialized.",
    "nav.support.user_management": "User Management",
    "support.user_management.create": "Create a New User",
    "support.user_management.validate": "Validate User",
    "support.user_management.add": "Add User",
    "support.user_management.user_details": "User Details",
    "support.user_management.name": "First Name",
    "support.user_management.surname": "Last Name",
    "support.user_management.email": "Email",
    "support.user_management.role_details": "Role Details",
    "support.user_management.market": "Market",
    "support.user_management.role": "Role",
    "support.user_management.agency": "Agency",
    "support.user_management.agencies": "Agencies",
    "support.user_management.client": "Client",
    "support.user_management.clients": "Clients",
    "support.user_management.team_lead": "Team Lead",
    "support.user_management.no_clients": "No clients for selected agency",
    "support.user_management.no_agencies": "No agencies for selected market",
    "support.user_management.user_valid": "User is valid!",
    "support.user_management.user_created": "User has been created!",
    "field.switch.on": "On",
    "field.switch.off": "Off",
    "reporting.aggrid.custompagination.page": "Page",
    "reporting.aggrid.custompagination.pageOf": "of",
    "reporting.aggrid.custompagination.morePages": "more",
    "bo.cancel.download": "Export",
    "bo.cancel.download.success": "File was successfully downloaded",
    "bo.cancel.download.error": "An error was occurred",
    "media.plan.line.items.error.posted.for.billing.vendor.change":
      "This action cannot be completed, because at least one Line Item with the Status of Posted for Billing exists in your selection. Please remove Posted for Billing selection.",
    "media.plan.line.items.error.posted.for.billing.date.change":
      "This action cannot be completed, because at least one Line Item with the Status of Posted for Billing exists in your selection. Please remove Posted for Billing selection.",
    "media.plan.line.items.error.posted.for.billing.counter":
      "There is %number% line with errors!",
    "market.admin.toggle.on": "On",
    "market.admin.media.types.limit.month": "Limit Line Item per Month:",
    "activity.CANCEL_BOOKING_ORDER": "Booking Order Canceled",
  },
}
